import classNames from 'classnames';
import { useId, type FC, type SVGProps } from 'react';

export const CarOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 26"
      fill="none"
      {...props}
    >
      <g id="car">
        <path
          id="Vector"
          d="M19.511 18.4688H6.48991C5.91461 18.4688 5.44824 18.0025 5.44824 17.4272V13.7813C5.44824 12.6307 6.38098 11.698 7.53157 11.698H18.4693C19.6199 11.698 20.5527 12.6307 20.5527 13.7813V17.4272C20.5527 18.0025 20.0863 18.4688 19.511 18.4688Z"
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M9.35417 15.0833C9.35417 15.371 9.12098 15.6042 8.83333 15.6042C8.54568 15.6042 8.3125 15.371 8.3125 15.0833C8.3125 14.7957 8.54568 14.5625 8.83333 14.5625C9.12098 14.5625 9.35417 14.7957 9.35417 15.0833Z"
          stroke="currentColor"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M17.6872 15.0833C17.6872 15.371 17.454 15.6042 17.1663 15.6042C16.8787 15.6042 16.6455 15.371 16.6455 15.0833C16.6455 14.7957 16.8787 14.5625 17.1663 14.5625C17.454 14.5625 17.6872 14.7957 17.6872 15.0833Z"
          stroke="currentColor"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M19.5103 11.698H6.48926L7.24079 7.18883C7.40821 6.18428 8.27736 5.448 9.29577 5.448H16.7038C17.7222 5.448 18.5914 6.18428 18.7588 7.18883L19.5103 11.698Z"
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M7.53125 18.9895V20.552"
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M18.4688 18.9895V20.552"
          stroke="currentColor"
          strokeWidth="1.5625"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const DocumentAddOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M11.25 19.75H7.75C6.64543 19.75 5.75 18.8546 5.75 17.75V7.25C5.75 6.14543 6.64543 5.25 7.75 5.25H14L18.25 9.5V11.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17 15.25V19.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 17.5H14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M18 9.75H13.75V5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmailSentOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.75 19.75L12 5.25L19.25 19.75L12 16.25L4.75 19.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 16V13.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const EmailOpenOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.75 9.25L12 5.25L19.25 9.25V17.75C19.25 18.8546 18.3546 19.75 17.25 19.75H6.75C5.64543 19.75 4.75 18.8546 4.75 17.75V9.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 9.5L13.25 13.75H10.75L5 9.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const EmailInboxOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.25 11.75L17.6644 6.20056C17.4191 5.34195 16.6344 4.75 15.7414 4.75H8.2586C7.36564 4.75 6.58087 5.34196 6.33555 6.20056L4.75 11.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2142 12.3689C9.95611 12.0327 9.59467 11.75 9.17085 11.75H4.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25V11.75H14.8291C14.4053 11.75 14.0439 12.0327 13.7858 12.3689C13.3745 12.9046 12.7276 13.25 12 13.25C11.2724 13.25 10.6255 12.9046 10.2142 12.3689Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExclamationIconOutline2: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.95203 16.8535L10.215 6.35653C10.953 4.88476 13.0537 4.88515 13.7911 6.35718L19.0493 16.8542C19.7155 18.1841 18.7485 19.75 17.2611 19.75H6.73989C5.25216 19.75 4.28523 18.1835 4.95203 16.8535Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 10.5V12.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5C11.5 16.2239 11.7239 16 12 16C12.2761 16 12.5 16.2239 12.5 16.5Z"
          stroke="currentColor"
        />
      </g>
    </svg>
  );
};

export const InformationCircleIconOutline2: FC<SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12 13V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9C12.5 9.27614 12.2761 9.5 12 9.5C11.7239 9.5 11.5 9.27614 11.5 9C11.5 8.72386 11.7239 8.5 12 8.5C12.2761 8.5 12.5 8.72386 12.5 9Z"
        stroke="currentColor"
      />
      <path
        d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClockIconOutline2: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M12 8V12L14 14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
};

export const PeppolOnboardingIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  const dropShadowId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 171 78"
      fill="none"
      {...props}
    >
      <defs>
        <filter id={dropShadowId} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="5" />
          <feOffset dx="0" dy="0" result="offsetblur" />
          <feFlood floodColor="rgba(205,201,211, 0.5)" />
          <feComposite in2="offsetblur" operator="in" />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <path
        d="M68.1667 42.3333L69.3176 41.4858C79.2933 34.1393 92.9797 34.4882 102.568 42.3333V42.3333"
        stroke="url(#paint0_linear_8687_3168)"
        strokeWidth="1.66667"
      />
      <path
        d="M68.1667 35.6667L69.3176 36.5142C79.2933 43.8607 92.9797 43.5118 102.568 35.6667V35.6667"
        stroke="url(#paint1_linear_8687_3168)"
        strokeWidth="1.66667"
      />

      <g filter={`url(#${dropShadowId})`}>
        <rect x="6.83334" y="7" width="64" height="64" rx="32" fill="white" />
        <path
          d="M54.8333 39.0007C54.8333 30.1642 47.6699 23.0007 38.8333 23.0007C29.9968 23.0007 22.8333 30.1642 22.8333 39.0007C22.8333 47.8373 29.9968 55.0007 38.8333 55.0007C47.6699 55.0007 54.8333 47.8373 54.8333 39.0007Z"
          fill="white"
        />
        <path
          d="M44.86 46.8307C44.0297 48.0941 42.911 49.0322 41.5038 49.6819C40.0967 50.3315 38.6167 50.6568 37.0649 50.6568C35.3684 50.6568 33.8165 50.3324 32.4813 49.7187C31.146 49.105 29.9913 48.2388 29.0523 47.1919C28.1142 46.1091 27.3918 44.8817 26.8867 43.4745C26.3817 42.0673 26.1292 40.5515 26.1292 38.9628C26.1292 37.3741 26.3817 35.8591 26.9236 34.4511C27.4286 33.0439 28.187 31.7805 29.1251 30.7337C30.0632 29.6868 31.2187 28.8566 32.554 28.2437C33.8893 27.63 35.4052 27.3416 37.0289 27.3416C38.6527 27.3416 40.1326 27.6659 41.4319 28.3524C42.7313 29.0381 43.7422 29.9043 44.5356 30.9511H44.6435V27.8834H50.1292V50.1159H44.9678V46.8675H44.86V46.8316V46.8307ZM31.6142 38.9628C31.6142 39.9009 31.7588 40.8031 32.0473 41.7061C32.3357 42.5724 32.7688 43.3299 33.3107 43.9795C33.8884 44.6292 34.574 45.1701 35.4043 45.5314C36.2346 45.9285 37.1727 46.1091 38.2195 46.1091C39.2664 46.1091 40.1326 45.9285 40.9629 45.5314C41.7932 45.1342 42.4788 44.6292 43.0925 43.9795C43.6703 43.3299 44.1393 42.5724 44.4637 41.7061C44.7881 40.8399 44.9328 39.9018 44.9328 38.9269C44.9328 37.9519 44.7881 37.0866 44.4637 36.1835C44.1393 35.3173 43.6694 34.5598 43.0925 33.9101C42.5147 33.2605 41.7932 32.7195 40.9629 32.3583C40.1326 31.9611 39.2304 31.7805 38.2195 31.7805C37.1368 31.7805 36.1987 31.9611 35.4043 32.3583C34.574 32.7554 33.8884 33.2605 33.3107 33.9101C32.7329 34.5598 32.3366 35.3173 32.0473 36.1835C31.7588 37.1216 31.6142 38.0238 31.6142 38.9628Z"
          fill="#8059C8"
        />
      </g>

      <g filter={`url(#${dropShadowId})`}>
        <rect x="100.167" y="7" width="64" height="64" rx="32" fill="white" />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M148.112 34.0771C147.806 32.8607 146.329 32.2083 143.609 32.088C142.527 30.3379 141.05 28.8655 139.297 27.7887C137.543 26.7119 135.562 26.0606 133.512 25.8868C132.458 23.5838 131.357 22.5282 130.165 22.6748C128.84 22.8346 128.066 24.467 127.651 26.741C125.704 27.4929 123.967 28.7028 122.586 30.2684C120.161 29.5732 118.651 29.723 117.982 30.7242C117.261 31.8054 117.83 33.4132 119.715 35.62C119.491 36.4621 119.352 37.3246 119.302 38.1945C116.923 39.6038 115.912 40.8875 116.221 42.1135C116.534 43.3562 118.132 43.9222 120.303 44.0746C121.195 46.1914 122.625 48.0381 124.451 49.4314C126.277 50.8246 128.436 51.7159 130.714 52.0169C131.604 53.9943 132.669 55.3391 133.898 55.3391C133.966 55.3391 134.035 55.335 134.103 55.3267C135.296 55.1831 136.11 53.9103 136.586 51.4419C137.99 50.9743 139.304 50.2709 140.471 49.362C141.373 49.6654 142.314 49.8374 143.265 49.8726C144.26 49.8726 144.949 49.5766 145.344 48.9847C145.984 48.025 145.605 46.655 144.189 44.804C145.281 42.6104 145.734 40.1542 145.497 37.7155C147.543 36.4201 148.401 35.2225 148.112 34.0771ZM143.709 36.6762C143.723 36.7421 143.732 36.8078 143.744 36.8736C143.558 36.9769 143.362 37.0828 143.151 37.1917C142.051 37.7526 140.922 38.2553 139.77 38.6977C139.547 38.4978 139.275 38.3617 138.981 38.3037C138.687 38.2457 138.384 38.268 138.102 38.3682C137.82 38.4683 137.57 38.6428 137.379 38.873C137.188 39.1032 137.062 39.3808 137.015 39.6764C135.697 40.1054 134.304 40.5073 132.866 40.8697C132.512 40.9589 132.159 41.0443 131.808 41.1257C131.579 40.6361 131.226 40.2141 130.786 39.9008C130.345 39.5874 129.831 39.3934 129.293 39.3375C129.112 37.8407 128.986 36.3726 128.915 34.967C128.917 34.9658 128.919 34.9649 128.921 34.9637C129.175 34.812 129.384 34.5954 129.526 34.3363C129.669 34.0772 129.74 33.7848 129.732 33.4892C129.725 33.1935 129.638 32.9053 129.482 32.654C129.326 32.4027 129.106 32.1974 128.845 32.0592C128.846 30.8448 128.91 29.6312 129.037 28.4235C129.056 28.2593 129.075 28.1032 129.095 27.9512C129.428 27.8515 129.767 27.7644 130.111 27.6939C130.878 27.5366 131.66 27.4571 132.443 27.4567C135.094 27.4642 137.662 28.385 139.714 30.0643C141.767 31.7435 143.177 34.0786 143.709 36.6762ZM131.824 50.4954C131.764 50.3406 131.703 50.1803 131.641 50.011C131.093 48.4725 130.646 46.9005 130.301 45.3045C130.581 45.1732 130.839 45.0011 131.068 44.7938C133.464 46.3104 135.987 47.6182 138.607 48.7025C137.421 49.4602 136.106 49.993 134.727 50.2743C133.772 50.4696 132.797 50.5439 131.824 50.4954ZM122.066 42.505C121.85 42.5082 121.644 42.5086 121.448 42.5061C121.32 42.1073 121.214 41.702 121.129 41.2919C120.844 39.9004 120.818 38.4681 121.054 37.0673C122.613 38.6074 124.278 40.0374 126.035 41.347C125.929 41.626 125.862 41.919 125.839 42.2168C124.587 42.3801 123.328 42.4763 122.066 42.505ZM128.688 40.9625C128.985 40.9073 129.292 40.9413 129.569 41.0602C129.847 41.1792 130.083 41.3777 130.247 41.6308C130.412 41.8839 130.498 42.18 130.494 42.4819C130.49 42.7838 130.397 43.0778 130.226 43.3267C130.056 43.5757 129.815 43.7684 129.535 43.8805C129.254 43.9926 128.947 44.0191 128.652 43.9565C128.356 43.894 128.086 43.7453 127.875 43.5292C127.664 43.3131 127.522 43.0394 127.467 42.7426C127.429 42.5454 127.431 42.3428 127.472 42.1463C127.513 41.9499 127.593 41.7635 127.707 41.598C127.82 41.4325 127.965 41.2911 128.134 41.1821C128.302 41.073 128.491 40.9984 128.688 40.9625ZM130.359 24.2788C130.361 24.2785 130.364 24.2783 130.368 24.2783C130.499 24.2783 131.003 24.5613 131.7 25.8625C131.057 25.8991 130.418 25.9821 129.788 26.1111C129.662 26.1367 129.539 26.1676 129.415 26.1966C129.788 24.7025 130.225 24.2949 130.359 24.2788ZM127.4 28.6063C127.296 29.7069 127.249 30.8871 127.245 32.0809C127.234 32.0871 127.223 32.0919 127.212 32.0984C126.956 32.2515 126.746 32.4704 126.604 32.7323C126.461 32.9942 126.391 33.2896 126.402 33.5876C126.412 33.8856 126.502 34.1754 126.663 34.4267C126.823 34.6781 127.048 34.8818 127.314 35.0166C127.393 36.6694 127.533 38.2392 127.689 39.5369C127.692 39.5551 127.694 39.5746 127.696 39.5929C127.438 39.7065 127.196 39.8546 126.978 40.0332C125.062 38.6143 123.268 37.0383 121.614 35.3216C121.582 35.2872 121.555 35.2559 121.523 35.2221C121.841 34.309 122.271 33.4391 122.804 32.6327C123.943 30.8991 125.532 29.5074 127.4 28.6063ZM119.326 31.6213C119.394 31.5193 119.956 31.2974 121.514 31.6587C121.495 31.6869 121.475 31.7138 121.456 31.7421C121.023 32.3991 120.649 33.0933 120.339 33.8164C119.283 32.4046 119.247 31.7396 119.326 31.6213ZM117.788 41.7186C117.757 41.5968 117.977 41.0196 119.329 40.0899C119.372 40.6022 119.444 41.1116 119.546 41.6155C119.6 41.8803 119.665 42.1411 119.734 42.3999C118.266 42.2155 117.82 41.8467 117.788 41.7186ZM126.068 48.5993C124.37 47.4828 123 45.9347 122.098 44.114C123.445 44.079 124.788 43.9719 126.124 43.7932C126.359 44.2981 126.724 44.7313 127.182 45.0484C127.64 45.3654 128.173 45.555 128.729 45.5976C129.069 47.1745 129.5 48.7306 130.02 50.258C128.61 49.9573 127.27 49.3947 126.068 48.5993ZM133.909 53.7227C133.775 53.7414 133.263 53.4539 132.557 52.1234C133.319 52.1132 134.079 52.0374 134.829 51.8967C134.455 53.3348 134.026 53.7087 133.909 53.7227ZM144 48.0876C143.926 48.1984 143.37 48.3989 141.901 48.07C142.415 47.5312 142.884 46.9498 143.301 46.3322C144.053 47.4463 144.073 47.979 144 48.0876ZM140.125 47.5457C139.987 47.4974 139.85 47.4491 139.704 47.3945C137.429 46.5432 134.731 45.163 131.952 43.4411C132.029 43.2058 132.077 42.9623 132.096 42.7156C132.503 42.6221 132.895 42.5284 133.261 42.4362C134.751 42.0608 136.196 41.6432 137.565 41.196C137.788 41.391 138.058 41.5232 138.349 41.5788C138.639 41.6344 138.939 41.6115 139.218 41.5124C139.497 41.4133 139.744 41.2416 139.934 41.0151C140.124 40.7886 140.251 40.5154 140.3 40.2237C141.525 39.7555 142.725 39.2224 143.893 38.6267C143.907 38.6193 143.92 38.6121 143.934 38.6047C143.987 40.2824 143.674 41.9514 143.016 43.4955C142.358 45.0396 141.371 46.4218 140.125 47.5457ZM145.202 35.9627C145.027 35.2144 144.787 34.4828 144.484 33.7761C146.053 33.9569 146.514 34.3478 146.546 34.4718C146.578 34.5982 146.367 35.1242 145.202 35.9627Z"
          fill="url(#paint2_radial_8687_3168)"
        />
      </g>

      <defs>
        <linearGradient
          id="paint0_linear_8687_3168"
          x1="68.5371"
          y1="41.963"
          x2="101.785"
          y2="41.963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9CDEF" />
          <stop offset="1" stopColor="#8059C8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8687_3168"
          x1="68.5371"
          y1="36.037"
          x2="101.785"
          y2="36.037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9CDEF" />
          <stop offset="1" stopColor="#8059C8" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_8687_3168"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(132.167 39.0001) scale(16.1702)"
        >
          <stop offset="0.28045" stopColor="#00BAFF" />
          <stop offset="0.97781" stopColor="#007AD7" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const RegenerateIconOutline: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.375 12.2918L7.29166 14.1668M7.29166 14.1668L9.375 16.0418M7.29166 14.1668H11.0417C13.8031 14.1668 16.0417 11.9283 16.0417 9.16683V8.9585"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12.7083 5.8335H8.95834C6.19691 5.8335 3.95834 8.07207 3.95834 10.8335V11.0418M12.7083 5.8335L10.625 7.7085M12.7083 5.8335L10.625 3.9585"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DoubleChatIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99151 14.5101C12.7865 14.5101 15.233 12.9956 15.233 9.63003C15.233 6.26449 12.7865 4.75 9.99151 4.75C7.19653 4.75 4.75 6.26449 4.75 9.63003C4.75 10.8662 5.08005 11.8526 5.6362 12.606C5.83794 12.8793 5.79543 13.5163 5.63421 13.8153C5.24836 14.5309 5.97738 15.315 6.76977 15.1333C7.3629 14.9974 7.98504 14.8134 8.5295 14.5666C8.72883 14.4762 8.94893 14.4398 9.16641 14.4644C9.43657 14.4949 9.7123 14.5101 9.99151 14.5101Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2272 10.5C18.8553 11.2712 19.2329 12.3078 19.2329 13.63C19.2329 14.8662 18.9029 15.8526 18.3467 16.606C18.145 16.8793 18.1875 17.5163 18.3487 17.8153C18.7346 18.5309 18.0055 19.315 17.2132 19.1333C16.62 18.9974 15.9979 18.8134 15.4534 18.5666C15.2541 18.4762 15.034 18.4398 14.8165 18.4644C14.5464 18.4949 14.2706 18.5101 13.9914 18.5101C12.6956 18.5101 11.4748 18.1846 10.5378 17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HeartIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9934 9.64436C14.0607 7.48008 10.8378 6.8979 8.41625 8.87972C5.9947 10.8616 5.65378 14.1751 7.55543 16.519L15.9934 24.3334L24.4314 16.519C26.3331 14.1751 26.0338 10.8407 23.5706 8.87972C21.1074 6.91874 17.9261 7.48008 15.9934 9.64436Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.3333 10.6666C20.3333 13.0598 18.3932 14.9999 16 14.9999C13.6067 14.9999 11.6666 13.0598 11.6666 10.6666C11.6666 8.27335 13.6067 6.33325 16 6.33325C18.3932 6.33325 20.3333 8.27335 20.3333 10.6666Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.12997 25.6667H22.87C24.3925 25.6667 25.5653 24.3576 24.8543 23.0113C23.8084 21.0308 21.4239 18.6667 16 18.6667C10.576 18.6667 8.19152 21.0308 7.14561 23.0113C6.43459 24.3576 7.60741 25.6667 9.12997 25.6667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PeppolColoredIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  const id1 = '_' + useId();
  const id2 = '_' + useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
      fill="none"
      {...props}
    >
      <g clipPath={'url(#' + id2 + ')'}>
        <path
          d="M17.9696 7.40035C17.7974 6.7161 16.9663 6.34916 15.4366 6.28146C14.8279 5.29705 13.9971 4.46883 13.0109 3.86313C12.0246 3.25742 10.9102 2.89104 9.75691 2.79333C9.16413 1.49788 8.5446 0.904092 7.87433 0.986537C7.12909 1.07646 6.69346 1.99465 6.4603 3.2738C5.36496 3.69671 4.38765 4.37731 3.6111 5.25798C2.24693 4.86689 1.39772 4.95117 1.02157 5.51435C0.615495 6.12249 0.935794 7.02689 1.99608 8.26823C1.87008 8.74191 1.79217 9.22709 1.76351 9.7164C0.425654 10.5091 -0.143064 11.2312 0.030702 11.9208C0.206846 12.6199 1.10553 12.9382 2.32659 13.0239C2.82835 14.2147 3.63282 15.2534 4.66014 16.0371C5.68745 16.8208 6.90189 17.3222 8.18287 17.4915C8.68369 18.6038 9.28262 19.3602 9.97397 19.3602C10.0125 19.3602 10.051 19.3579 10.0892 19.3533C10.7603 19.2725 11.2183 18.5565 11.4859 17.1681C12.2756 16.905 13.0147 16.5094 13.6716 15.9981C14.1789 16.1688 14.7081 16.2655 15.243 16.2853C15.8028 16.2853 16.1901 16.1188 16.4124 15.7859C16.7727 15.2461 16.5591 14.4754 15.7628 13.4342C16.3769 12.2003 16.6317 10.8187 16.4983 9.44694C17.6495 8.71827 18.132 8.04464 17.9696 7.40035ZM15.4929 8.86237C15.5005 8.89939 15.5058 8.93635 15.5127 8.97337C15.408 9.0315 15.2973 9.09103 15.1788 9.15234C14.5602 9.46784 13.9253 9.75059 13.2769 9.99942C13.1517 9.88698 12.9984 9.81042 12.8332 9.77779C12.6681 9.74517 12.4972 9.7577 12.3386 9.81406C12.18 9.87043 12.0395 9.96853 11.932 10.098C11.8244 10.2276 11.7538 10.3837 11.7276 10.5499C10.9859 10.7913 10.2023 11.0174 9.3934 11.2212C9.19415 11.2714 8.99585 11.3194 8.7985 11.3652C8.66938 11.0898 8.47124 10.8524 8.22331 10.6762C7.97538 10.4999 7.68609 10.3908 7.38352 10.3593C7.28209 9.51736 7.21128 8.69155 7.17096 7.90092C7.1721 7.90022 7.1733 7.89974 7.17448 7.89904C7.31728 7.8137 7.4348 7.69191 7.51499 7.54616C7.59518 7.40041 7.63515 7.23595 7.6308 7.06965C7.62645 6.90335 7.57793 6.7412 7.49022 6.59984C7.40252 6.45849 7.27878 6.34301 7.13171 6.26526C7.13238 5.58216 7.16853 4.89955 7.23999 4.2202C7.25023 4.12786 7.26114 4.04003 7.27239 3.95454C7.45972 3.89847 7.6501 3.84943 7.84402 3.80977C8.27555 3.7213 8.71491 3.67662 9.15541 3.67639C10.6469 3.68058 12.0915 4.19856 13.2458 5.14313C14.4001 6.08771 15.1937 7.40117 15.4929 8.86237ZM8.80747 16.6356C8.77346 16.5486 8.73909 16.4584 8.70429 16.3632C8.39648 15.4978 8.14475 14.6135 7.95065 13.7157C8.10799 13.6419 8.25347 13.5451 8.38234 13.4285C9.73017 14.2816 11.1489 15.0172 12.6228 15.6271C11.9558 16.0533 11.2159 16.353 10.4403 16.5112C9.90342 16.6212 9.35481 16.6629 8.80747 16.6356ZM3.3185 12.141C3.19684 12.1428 3.08097 12.143 2.97087 12.1416C2.89895 11.9173 2.8391 11.6894 2.79156 11.4587C2.63096 10.6759 2.61654 9.87028 2.74902 9.08232C3.62626 9.94866 4.56261 10.753 5.55131 11.4897C5.49123 11.6466 5.45398 11.8114 5.44071 11.9789C4.73671 12.0708 4.02829 12.1249 3.3185 12.141ZM7.04359 11.2734C7.21055 11.2423 7.38296 11.2614 7.53905 11.3284C7.69513 11.3953 7.82787 11.507 7.92048 11.6493C8.01308 11.7916 8.0614 11.9583 8.05931 12.1281C8.05723 12.2979 8.00484 12.4632 7.90877 12.6033C7.81269 12.7433 7.67725 12.8517 7.51957 12.9148C7.3619 12.9778 7.18906 12.9927 7.02292 12.9575C6.85679 12.9224 6.70481 12.8387 6.58621 12.7172C6.46762 12.5956 6.38773 12.4416 6.35665 12.2747C6.33548 12.1638 6.33649 12.0498 6.35962 11.9393C6.38275 11.8288 6.42755 11.724 6.49142 11.6309C6.55529 11.5378 6.63697 11.4582 6.73175 11.3969C6.82652 11.3355 6.93251 11.2936 7.04359 11.2734ZM7.98311 1.88878C7.98463 1.88865 7.98641 1.88853 7.98831 1.88853C8.06204 1.88853 8.34586 2.04772 8.73751 2.77961C8.37609 2.8002 8.01662 2.84694 7.66195 2.91946C7.59155 2.93385 7.52229 2.95125 7.45262 2.96758C7.66214 2.12714 7.90805 1.89785 7.98311 1.88878ZM6.31898 4.32303C6.26022 4.94212 6.23397 5.60599 6.23188 6.27747C6.22573 6.28096 6.21939 6.28369 6.2133 6.28733C6.06935 6.37343 5.95111 6.49656 5.87093 6.64389C5.79074 6.79122 5.75153 6.95736 5.75738 7.12499C5.76323 7.29263 5.81394 7.45563 5.90421 7.59701C5.99448 7.73839 6.12101 7.85297 6.27063 7.92881C6.31525 8.85853 6.39364 9.7415 6.48167 10.4715C6.4829 10.4817 6.48436 10.4927 6.4856 10.503C6.3403 10.5669 6.20435 10.6502 6.08146 10.7507C5.00391 9.9525 3.9947 9.06601 3.06428 8.10036C3.04622 8.08102 3.03088 8.06343 3.01328 8.04441C3.19177 7.53077 3.4338 7.04146 3.73374 6.58789C4.37444 5.61271 5.268 4.82989 6.31898 4.32303ZM1.7775 6.01897C1.81579 5.9616 2.13194 5.83677 3.00806 6.04002C2.99741 6.05587 2.98593 6.07099 2.97541 6.08693C2.73184 6.45648 2.52159 6.84694 2.34716 7.25372C1.75321 6.45957 1.73299 6.08551 1.7775 6.01897ZM0.911894 11.6987C0.894714 11.6302 1.01824 11.3055 1.77873 10.7825C1.803 11.0707 1.8439 11.3573 1.90124 11.6407C1.93167 11.7896 1.96793 11.9363 2.00692 12.0819C1.18126 11.9782 0.93012 11.7707 0.911894 11.6987ZM5.56953 15.5691C4.6146 14.941 3.84392 14.0703 3.33657 13.0461C4.09405 13.0264 4.84994 12.9662 5.60098 12.8657C5.73322 13.1496 5.93863 13.3933 6.19614 13.5717C6.45366 13.75 6.75399 13.8567 7.06632 13.8806C7.2579 14.7677 7.50033 15.6429 7.79242 16.5021C6.99959 16.333 6.24557 16.0165 5.56953 15.5691ZM9.98044 18.451C9.90494 18.4615 9.6168 18.2998 9.21976 17.5514C9.64853 17.5457 10.076 17.503 10.4975 17.4239C10.2874 18.2328 10.0462 18.4431 9.98044 18.451ZM15.6565 15.2813C15.6149 15.3436 15.3021 15.4564 14.4755 15.2714C14.7651 14.9683 15.0287 14.6413 15.2633 14.2938C15.6863 14.9205 15.6973 15.2202 15.6565 15.2813ZM13.4765 14.9765C13.3993 14.9493 13.3223 14.9221 13.2401 14.8914C11.9604 14.4125 10.4424 13.6362 8.87961 12.6676C8.92266 12.5353 8.9498 12.3983 8.96047 12.2595C9.18958 12.2069 9.40969 12.1542 9.61554 12.1024C10.4537 11.8912 11.2667 11.6563 12.037 11.4047C12.1621 11.5144 12.3142 11.5888 12.4776 11.6201C12.641 11.6513 12.8098 11.6384 12.9666 11.5827C13.1234 11.527 13.2624 11.4304 13.3694 11.303C13.4764 11.1755 13.5474 11.0219 13.5752 10.8578C14.2643 10.5944 14.939 10.2946 15.5964 9.95949C15.6044 9.95534 15.6116 9.95128 15.6196 9.94713C15.6492 10.8908 15.4729 11.8296 15.1028 12.6982C14.7327 13.5668 14.1777 14.3442 13.4765 14.9765ZM16.3328 8.46099C16.2342 8.04006 16.099 7.62853 15.9289 7.23106C16.8111 7.33274 17.0708 7.5526 17.0884 7.62236C17.1063 7.69349 16.9879 7.98936 16.3328 8.46099Z"
          fill={'url(#' + id1 + ')'}
        />
      </g>
      <defs>
        <radialGradient
          id={id1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.00017 10.1695) scale(9.09576)"
        >
          <stop offset="0.28045" stopColor="#00BAFF" />
          <stop offset="0.97781" stopColor="#007AD7" />
        </radialGradient>
        <clipPath id={id2}>
          <rect
            width="18"
            height="18.3812"
            fill="white"
            transform="translate(0 0.979004)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShieldTickIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M12 4.75L4.74999 8C4.74999 8 3.99999 19.25 12 19.25C20 19.25 19.25 8 19.25 8L12 4.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 12.75L11 14.25L14.25 9.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ArrowLeftIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M13.6666 23L6.33329 16L13.6666 9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M6.66663 15.25C6.25241 15.25 5.91663 15.5858 5.91663 16C5.91663 16.4142 6.25241 16.75 6.66663 16.75L6.66663 15.25ZM25.6666 16.75L26.4166 16.75L26.4166 15.25L25.6666 15.25L25.6666 16.75ZM6.66663 16.75L25.6666 16.75L25.6666 15.25L6.66663 15.25L6.66663 16.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const CloudIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 14C4.75 15.7949 6.20507 17.25 8 17.25H16C17.7949 17.25 19.25 15.7949 19.25 14C19.25 12.2869 17.9246 10.8834 16.2433 10.759C16.1183 8.5239 14.2663 6.75 12 6.75C9.73368 6.75 7.88168 8.5239 7.75672 10.759C6.07542 10.8834 4.75 12.2869 4.75 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileCheckMarkIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12.75 4.75H7.75C6.64543 4.75 5.75 5.64543 5.75 6.75V17.25C5.75 18.3546 6.64543 19.25 7.75 19.25H11.25M12.75 4.75V8.25C12.75 9.35457 13.6454 10.25 14.75 10.25H18.25M12.75 4.75L18.25 10.25M18.25 10.25V11.25M19.25 14.75C19.25 14.75 17.3214 16.8393 16.3571 19.25L14.75 17.3214"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WarningIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M12 11.0005L12 9.00049"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M11.5 15.0005C11.5 14.7243 11.7239 14.5005 12 14.5005C12.2761 14.5005 12.5 14.7243 12.5 15.0005C12.5 15.2766 12.2761 15.5005 12 15.5005C11.7239 15.5005 11.5 15.2766 11.5 15.0005Z"
          stroke="currentColor"
        />
        <path
          d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const UsersIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M5.78164 19.25H13.2183C13.7828 19.25 14.227 18.7817 14.1145 18.2285C13.8039 16.7012 12.7896 14 9.49996 14C6.21027 14 5.19601 16.7012 4.88545 18.2285C4.77296 18.7817 5.21714 19.25 5.78164 19.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 14C17.8288 14 18.6802 16.1479 19.0239 17.696C19.2095 18.532 18.5333 19.25 17.6769 19.25H16.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 7.5C12.25 9.01878 11.0188 10.25 9.5 10.25C7.98122 10.25 6.75 9.01878 6.75 7.5C6.75 5.98122 7.98122 4.75 9.5 4.75C11.0188 4.75 12.25 5.98122 12.25 7.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.75 10.25C16.2688 10.25 17.25 9.01878 17.25 7.5C17.25 5.98122 16.2688 4.75 14.75 4.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ChecklistIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.75 6.50758C4.75 5.53689 5.53689 4.75 6.50758 4.75H17.4924C18.4631 4.75 19.25 5.53689 19.25 6.50758V17.4924C19.25 18.4631 18.4631 19.25 17.4924 19.25H6.50758C5.53689 19.25 4.75 18.4631 4.75 17.4924V6.50758Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7888 9.56348H15.9858"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M13.7379 15.0361H15.9349"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M8 9.53984L8.9 10.4398L11 8.33984"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M8 14.74L8.9 15.64L11 13.54"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const AtSymbolIconOutLine: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M5.404 14.596A6.5 6.5 0 1 1 16.5 10a1.25 1.25 0 0 1-2.5 0 4 4 0 1 0-.571 2.06A2.75 2.75 0 0 0 18 10a8 8 0 1 0-2.343 5.657.75.75 0 0 0-1.06-1.06 6.5 6.5 0 0 1-9.193 0ZM10 7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const KeyIconSolidMiniIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M8 7a5 5 0 1 1 3.61 4.804l-1.903 1.903A1 1 0 0 1 9 14H8v1a1 1 0 0 1-1 1H6v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 .293-.707L8.196 8.39A5.002 5.002 0 0 1 8 7Zm5-3a.75.75 0 0 0 0 1.5A1.5 1.5 0 0 1 14.5 7 .75.75 0 0 0 16 7a3 3 0 0 0-3-3Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const InfoIconOutline = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M10 10.8333V12.5"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M10.4167 7.49998C10.4167 7.7301 10.2301 7.91665 10 7.91665C9.76989 7.91665 9.58334 7.7301 9.58334 7.49998C9.58334 7.26986 9.76989 7.08331 10 7.08331C10.2301 7.08331 10.4167 7.26986 10.4167 7.49998Z"
          stroke="currentColor"
          strokeWidth="0.833333"
        />
        <path
          d="M16.0417 9.99998C16.0417 13.3367 13.3367 16.0416 10 16.0416C6.66329 16.0416 3.95834 13.3367 3.95834 9.99998C3.95834 6.66326 6.66329 3.95831 10 3.95831C13.3367 3.95831 16.0417 6.66326 16.0417 9.99998Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 8.75C4.75 7.64543 5.64543 6.75 6.75 6.75H17.25C18.3546 6.75 19.25 7.64543 19.25 8.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V8.75Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4.75V8.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M16 4.75V8.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 10.75H16.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const XIconIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M17.25 6.75L6.75 17.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 6.75L17.25 17.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RetryIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={classNames('rotate-180', props.className)}
    >
      <path
        d="M6.87348 17.1265L7.40381 16.5962L6.87348 17.1265ZM17.1265 17.1265L16.5962 16.5962V16.5962L17.1265 17.1265ZM16.5962 7.40381L17.1265 7.93414L18.1872 6.87348L17.6569 6.34315L16.5962 7.40381ZM6.87348 6.87348L7.40381 7.40381H7.40381L6.87348 6.87348ZM19.2851 15.3103C19.4564 14.9332 19.2896 14.4886 18.9125 14.3173C18.5353 14.146 18.0907 14.3128 17.9194 14.69L19.2851 15.3103ZM6.34315 17.6569C9.46734 20.781 14.5327 20.781 17.6569 17.6569L16.5962 16.5962C14.0578 19.1346 9.94221 19.1346 7.40381 16.5962L6.34315 17.6569ZM17.6569 6.34315C14.5327 3.21895 9.46734 3.21895 6.34315 6.34315L7.40381 7.40381C9.94221 4.8654 14.0578 4.8654 16.5962 7.40381L17.6569 6.34315ZM6.34315 6.34315C3.21895 9.46734 3.21895 14.5327 6.34315 17.6569L7.40381 16.5962C4.8654 14.0578 4.8654 9.94221 7.40381 7.40381L6.34315 6.34315ZM17.6569 17.6569C18.3553 16.9584 18.8985 16.1616 19.2851 15.3103L17.9194 14.69C17.606 15.3799 17.1654 16.027 16.5962 16.5962L17.6569 17.6569Z"
        fill="currentColor"
      />
      <path
        d="M19.25 19.25V15.75C19.25 15.1977 18.8023 14.75 18.25 14.75H14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AttachmentIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M7 11V14.6C7 17.2509 9.14903 19.4 11.8 19.4H12.2C14.851 19.4 17 17.2509 17 14.6V7.99998C17 6.12221 15.4778 4.59998 13.6 4.59998C11.7222 4.59998 10.2 6.12221 10.2 7.99998V14.3C10.2 15.2389 10.9611 16 11.9 16C12.8389 16 13.6 15.2389 13.6 14.3V8.59998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SettingsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.62117 14.9627L6.72197 15.1351C7.53458 15.2623 8.11491 16.0066 8.05506 16.8451L7.97396 17.9816C7.95034 18.3127 8.12672 18.6244 8.41885 18.7686L9.23303 19.1697C9.52516 19.3139 9.87399 19.2599 10.1126 19.0352L10.9307 18.262C11.5339 17.6917 12.4646 17.6917 13.0685 18.262L13.8866 19.0352C14.1252 19.2608 14.4733 19.3139 14.7662 19.1697L15.5819 18.7678C15.8733 18.6244 16.0489 18.3135 16.0253 17.9833L15.9441 16.8451C15.8843 16.0066 16.4646 15.2623 17.2772 15.1351L18.378 14.9627C18.6985 14.9128 18.9568 14.6671 19.0292 14.3433L19.23 13.4428C19.3025 13.119 19.1741 12.7831 18.9064 12.5962L17.9875 11.9526C17.3095 11.4774 17.1024 10.5495 17.5119 9.82051L18.067 8.83299C18.2284 8.54543 18.2017 8.18538 17.9993 7.92602L17.4363 7.2035C17.2339 6.94413 16.8969 6.83701 16.5867 6.93447L15.5221 7.26794C14.7355 7.51441 13.8969 7.1012 13.5945 6.31908L13.1866 5.26148C13.0669 4.95218 12.7748 4.7492 12.4496 4.75L11.5472 4.75242C11.222 4.75322 10.9307 4.95782 10.8126 5.26793L10.4149 6.31344C10.1157 7.1004 9.27319 7.51683 8.4842 7.26874L7.37553 6.92078C7.0645 6.82251 6.72591 6.93044 6.52355 7.19142L5.96448 7.91474C5.76212 8.17652 5.73771 8.53738 5.90228 8.82493L6.47 9.81487C6.88812 10.5446 6.68339 11.4814 6.00149 11.9591L5.0936 12.5954C4.82588 12.7831 4.69754 13.119 4.76998 13.442L4.97077 14.3425C5.04242 14.6671 5.30069 14.9128 5.62117 14.9627Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5911 10.4089C14.4696 11.2875 14.4696 12.7125 13.5911 13.5911C12.7125 14.4696 11.2875 14.4696 10.4089 13.5911C9.53036 12.7125 9.53036 11.2875 10.4089 10.4089C11.2875 9.53036 12.7125 9.53036 13.5911 10.4089Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const QuestionMarkCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <circle
          cx="12"
          cy="12"
          r="7.25"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M10.7109 8.97649C11.5018 8.28453 12.7839 8.28453 13.5748 8.97649C14.3656 9.66845 14.3656 10.7903 13.5748 11.4823C13.4371 11.6027 13.2846 11.7022 13.1224 11.7807C12.619 12.0243 12.1429 12.4546 12.1429 13.0138V13.52M12.1427 15.545H12.1478V15.5501H12.1427V15.545Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const EmailSendOutLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M16.75 19.5005L19.25 17.2505M19.25 17.2505L16.75 15.0005M19.25 17.2505H13.85"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 11.3005V6.75049C19.25 5.64592 18.3546 4.75049 17.25 4.75049H6.75C5.64543 4.75049 4.75 5.64592 4.75 6.75049V15.2505C4.75 16.3551 5.64543 17.2505 6.75 17.2505H10.3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 5.50049L12 11.2505L18.5 5.50049"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Send2OutLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M6.79811 11.9999H9.60612M6.79811 11.9999L4.53591 5.21337C4.41421 4.84825 4.7947 4.51825 5.13894 4.69037L18.9853 11.6135C19.3038 11.7727 19.3038 12.2271 18.9853 12.3863L5.13894 19.3095C4.7947 19.4816 4.41421 19.1516 4.53591 18.7865L6.79811 11.9999Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FloppyDiskIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M8.75 19V15.75C8.75 15.1977 9.19772 14.75 9.75 14.75H14.25C14.8023 14.75 15.25 15.1977 15.25 15.75V19M8.75 5V8.25M17.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H14.1716C14.702 4.75 15.2107 4.96071 15.5858 5.33579L18.6642 8.41421C19.0393 8.78929 19.25 9.29799 19.25 9.82843V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileEuroOutLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="2 2 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M13.75 4.74991L18.25 9.24991H13.75V4.74991ZM13.75 4.74991H7.75C6.64543 4.74991 5.75 5.64534 5.75 6.74991V17.2499C5.75 18.3545 6.64543 19.2499 7.75 19.2499H12.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7404 16.2209H15.7024M18.203 14.1089C17.7888 13.5653 17.2156 13.2289 16.5824 13.2289C15.3188 13.2289 14.2944 14.5685 14.2944 16.2209C14.2944 17.8733 15.3188 19.2128 16.5824 19.2128C17.2156 19.2128 17.7888 18.8764 18.203 18.3329"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.79968 10.8891H9.79968"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.79968 13.7875H10.7997"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileMissingIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M12.75 4.75L17.25 9.25H13.75C13.1977 9.25 12.75 8.80228 12.75 8.25V4.75ZM12.75 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H11.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.79968 10.7891H9.19968"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.79968 13.6875H10.7997"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3717 13.3596C15.016 12.7957 16.0607 12.7957 16.7051 13.3596C17.3494 13.9234 17.3494 14.8376 16.7051 15.4014C16.5929 15.4996 16.4686 15.5806 16.3365 15.6446C15.9263 15.8431 15.5384 16.1937 15.5384 16.6493V17.0618M15.5383 19.2119H15.5424V19.216H15.5383V19.2119Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const BelgiumFlagIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M11.0689 2.24816C10.3467 1.98019 9.56557 1.8335 8.7501 1.8335C7.93464 1.8335 7.15349 1.98019 6.43128 2.24816L5.85156 8.50016L6.43128 14.7522C7.15349 15.0202 7.93464 15.1668 8.7501 15.1668C9.56557 15.1668 10.3467 15.0202 11.0689 14.7522L11.6486 8.50016L11.0689 2.24816Z"
          fill="#FFDA44"
        />
        <path
          d="M15.4167 8.50003C15.4167 5.63362 13.6075 3.18997 11.0688 2.24805V14.7521C13.6075 13.8101 15.4167 11.3665 15.4167 8.50003Z"
          fill="#D80027"
        />
        <path
          d="M2.0835 8.50003C2.0835 11.3665 3.89266 13.8101 6.43133 14.7521V2.24805C3.89266 3.18997 2.0835 5.63362 2.0835 8.50003Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export const GermanyFlagIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M2.62207 15.4782C4.035 19.2862 7.70043 22 12.0001 22C16.2997 22 19.9652 19.2862 21.3781 15.4782L12.0001 14.6087L2.62207 15.4782Z"
          fill="#FFDA44"
        />
        <path
          d="M12.0001 2C7.70043 2 4.035 4.71375 2.62207 8.52176L12.0001 9.39129L21.3781 8.52172C19.9652 4.71375 16.2997 2 12.0001 2Z"
          fill="black"
        />
        <path
          d="M2.62199 8.52173C2.22004 9.60505 2 10.7768 2 12C2 13.2232 2.22004 14.3949 2.62199 15.4782H21.378C21.78 14.3949 22 13.2232 22 12C22 10.7768 21.78 9.60505 21.378 8.52173H2.62199Z"
          fill="#D80027"
        />
      </g>
    </svg>
  );
};

export const GlobeIcon = (props: SVGProps<SVGSVGElement>) => {
  const id = `_${useId()}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
          stroke="#291547"
          strokeWidth="1.379"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.483 12c0 6.207-2.769 10-4.483 10-1.714 0-4.483-3.793-4.483-10S10.287 2 12 2c1.714 0 4.483 3.793 4.483 10ZM2.345 12h19.31"
          stroke="#291547"
          strokeWidth="1.379"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.742 11.987c0 .483-.032.959-.094 1.425-.697 5.266-5.204 9.33-10.662 9.33-2.092 0-4.045-.598-5.697-1.631a10.778 10.778 0 0 1-4.694-6.34 10.772 10.772 0 0 1-.364-2.784c0-5.614 4.3-10.223 9.786-10.713.32-.028.643-.043.97-.043 5.94 0 10.755 4.815 10.755 10.756Z"
          fill="#2563EB"
        />
        <path
          d="M7.229 3.695c-.107.07-.241.078-.363.115-.121.037-.248.128-.248.255 0 .096.076.179.164.217.088.039.187.041.284.043l.501.01A.534.534 0 0 0 7.82 4.3c.163-.082.196-.297.21-.48a1.615 1.615 0 0 0-.017-.495c-.056-.226-.255-.48-.458-.257-.163.178-.097.476-.326.627ZM15.203 19.765c-.027.02-.056.04-.073.07-.031.053-.013.122.018.176.139.248.475.297.757.268a.6.6 0 0 0 .229-.06.606.606 0 0 0 .181-.177 3.008 3.008 0 0 0 .594-1.798c0-.042-.004-.09-.036-.116-.034-.027-.083-.02-.125-.007-.368.109-.575.357-.736.679-.192.381-.46.715-.809.965ZM6.289 21.11a10.778 10.778 0 0 1-4.694-6.339c1.105.533 1.578 1.448 2.73 1.868.581.211 1.2.431 1.583.916.412.522.46 1.26.286 1.9-.173.642.457 1.097.095 1.655Z"
          fill="#34D399"
        />
        <path
          d="M11.986 1.231c-.326 0-.65.015-.97.043-.362.384-1.287.533-1.594 1.185-.048.103-.099.212-.092.326.01.155.128.288.268.355.14.068.3.082.455.087.119.004.24.003.356-.02.185-.038.266-.19.395-.329.089-.174.33-.612.454-.764.289-.353 1.055-.37.8.106-.285.533-.484.674-.578 1.09-.055.245-.117.503-.285.69-.188.212-.725-.022-1.292.079-.567.101-1.193-.233-1.193.257.032.786.1.79-.28 1.247-.379.458-1.076.127-1.44.309-.168.084-.073.739-.121.92-.047.175.041.365.181.48.14.113.323.162.502.182.437.049.89-.058 1.258-.297.241-.156.447-.367.706-.492.258-.126.9-.217 1.097-.01.22.231.136 1.04.444 1.12.245.062.238-.466.365-.685.126-.219.298-.477.55-.46.119.008.223.079.313.155.284.238.166.953.537.938.2-.008.55-.294.805-.556-.7.173.187.8.415.876.23.077.996-.16 1.152.025a.354.354 0 0 1 .093.175c.018.141-.11.256-.233.328-.458.264-.79.63-1.267.858-1.987.95-2.717-1.213-5.83-1.312-.98.207-.806.611-1.35 1.024-.37.28-.495.52-.701.934-.351.701-.111 1.553.24 2.255.243.482.555.96 1.03 1.218.251.137.534.204.813.27l1.26.297c.18.042.364.087.507.203.148.12.231.303.309.478.166.376.334.755.429 1.156.08.337.107.685.205 1.017.202.682.69 2.055.91 2.732.055.167.093.343.18.496.107.185.28.327.478.409.375.155.814.09 1.18-.088.365-.177.671-1.262.965-1.543.89-.854 1.757-1.842 1.973-3.057.052-.296.07-.613.243-.86.17-.242.457-.368.696-.542.296-.215.53-.516.663-.857.067-.171.11-.363.059-.54-.116-.401-.607-.525-.974-.724-1.528-1.072 1.704-.624 2.437-1.028.174-.096.351-.194.49-.337.062-.064.119-.145.114-.235-.002-.057-.072-.766-.099-.817-.128-1.247 1.264-1.247 1.537 1.345.035.471.195.945.518 1.29.323.345.118.886.578.779.063-.466.095-.942.095-1.425 0-5.94-4.815-10.756-10.756-10.756Zm2.764 6.066c-.273-.014-.878-.232-1.123-.11.122-.125.223-.245.276-.325.162-.25.3-.531.55-.695.292-.192.68-.176 1.008-.059.233.084.47.243.516.487.051.269-.163.53-.417.632-.254.101-.537.083-.81.07Z"
          fill="#34D399"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const XMLIcon: FC<{ className?: string }> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.527 11.85h-.893l-.823 1.439h-.036L.943 11.85H.012l1.227 1.983L0 15.85h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992 1.274-2.007Zm.954 3.999v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596h-.025L4.58 11.85h-.806v3.999h.706Zm4.71-.674h1.696v.674H8.4V11.85h.791v3.325Z"
      />
    </svg>
  );
};

export const FileTextIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g id="file-text">
        <path
          id="Vector"
          d="M18 9.25H13.75V5M9.75 15.25H14.25M9.75 12.25H14.25M16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V6.75C5.75 5.64543 6.64543 4.75 7.75 4.75H14L18.25 9V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const SendOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g>
        <path
          d="M4.75 19.25L12 4.75L19.25 19.25L12 15.75L4.75 19.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15.5V12.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const Sparkles2Icon = (
  props: SVGProps<SVGSVGElement> & { overrideClassName?: string },
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={
        props.overrideClassName
          ? props.overrideClassName
          : classNames(props.className, 'text-[#8059C8]')
      }
    >
      <path
        d="M17 4.75C17 5.89705 15.8971 7 14.75 7C15.8971 7 17 8.10295 17 9.25C17 8.10295 18.1029 7 19.25 7C18.1029 7 17 5.89705 17 4.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14.75C17 15.8971 15.8971 17 14.75 17C15.8971 17 17 18.1029 17 19.25C17 18.1029 18.1029 17 19.25 17C18.1029 17 17 15.8971 17 14.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 7.75C9 9.91666 6.91666 12 4.75 12C6.91666 12 9 14.0833 9 16.25C9 14.0833 11.0833 12 13.25 12C11.0833 12 9 9.91666 9 7.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RowsOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M5.75 10.7502H18.25C18.8023 10.7502 19.25 10.3025 19.25 9.75025V6.25C19.25 5.69772 18.8023 5.25 18.25 5.25H5.75C5.19772 5.25 4.75 5.69772 4.75 6.25V9.75025C4.75 10.3025 5.19772 10.7502 5.75 10.7502Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 19.7502H18.25C18.8023 19.7502 19.25 19.3025 19.25 18.7502V15.25C19.25 14.6977 18.8023 14.25 18.25 14.25H5.75C5.19772 14.25 4.75 14.6977 4.75 15.25V18.7502C4.75 19.3025 5.19772 19.7502 5.75 19.7502Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TooltipArrowIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg viewBox="0 0 20 10" fill="none" {...props}>
      <path
        d="M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
        fill="currentColor"
      />
      <path d="M8.99542 1.85876C9.75604 1.17425 10.9106 1.17422 11.6713 1.85878L16.5281 6.22989C17.0789 6.72568 17.7938 7.00001 18.5349 7.00001L15.89 7L11.0023 2.60207C10.622 2.2598 10.0447 2.2598 9.66436 2.60207L4.77734 7L2.13171 7.00001C2.87284 7.00001 3.58774 6.72568 4.13861 6.22989L8.99542 1.85876Z" />
      <path d="M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z" />
    </svg>
  );
};

export const VerificationWizardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 170 173"
      {...props}
    >
      <g filter="url(#a)">
        <path
          d="m80.273 6.691-68.482 30.7 1.812 4.042-1.812-4.043c-3.836 1.72-6.598 5.434-6.7 9.933-.234 10.29.117 39.107 10.072 65.531 4.994 13.257 12.511 26.199 23.857 35.849 11.436 9.727 26.482 15.864 45.98 15.864 19.498 0 34.544-6.137 45.98-15.864 11.346-9.65 18.863-22.592 23.857-35.849 9.955-26.424 10.306-55.24 10.072-65.53-.102-4.5-2.864-8.214-6.7-9.934L89.727 6.691a11.556 11.556 0 0 0-9.454 0Z"
          stroke="#C6B5F4"
          strokeWidth="9.905"
        />
      </g>
      <g filter="url(#b)">
        <path
          d="m82.299 11.21-68.483 30.7c-2.23 1-3.718 3.083-3.773 5.526C9.583 67.658 11.53 159.614 85 159.614s75.417-91.956 74.957-112.178c-.055-2.443-1.544-4.527-3.774-5.526l-68.482-30.7a6.604 6.604 0 0 0-5.402 0Z"
          fill="#F6F3FE"
        />
      </g>
      <path
        d="m69 90.14 8.888 10.667 23.111-32"
        stroke="#7431D2"
        strokeWidth="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="a"
          x=".094"
          y=".728"
          width="169.812"
          height="168.792"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="13.815" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.338929 0 0 0 0 0.57946 0 0 0 0.2 0" />
          <feBlend in2="shape" result="effect1_innerShadow_8116_36788" />
        </filter>
        <filter
          id="b"
          x="3.75"
          y="10.633"
          width="162.5"
          height="161.481"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.25" />
          <feGaussianBlur stdDeviation="3.125" />
          <feColorMatrix values="0 0 0 0 0.207843 0 0 0 0 0.101961 0 0 0 0 0.301961 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8116_36788"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_8116_36788"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const FileSearchIcon2 = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9.85002 20.2002H6.70002C5.70591 20.2002 4.90002 19.3943 4.90002 18.4002V5.35017C4.90002 4.35606 5.70591 3.55017 6.70002 3.55017H16.15C17.1441 3.55017 17.95 4.35606 17.95 5.35017V10.7502M19.075 20.4252L17.8807 19.1923M17.8807 19.1923C18.4802 18.5831 18.85 17.7473 18.85 16.8252C18.85 14.9612 17.339 13.4502 15.475 13.4502C13.6111 13.4502 12.1 14.9612 12.1 16.8252C12.1 18.6891 13.6111 20.2002 15.475 20.2002C16.4168 20.2002 17.2685 19.8144 17.8807 19.1923ZM8.50002 7.15017H14.35M8.50002 10.7502H11.65"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileErrorIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        id="Vector"
        d="M12.75 4.75L17.25 9.25H13.75C13.1977 9.25 12.75 8.80228 12.75 8.25V4.75ZM12.75 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H9.25M13.6125 14.5C14.105 14.035 14.7692 13.75 15.5 13.75C17.0188 13.75 18.25 14.9812 18.25 16.5C18.25 17.2308 17.965 17.895 17.5 18.3875M13.6125 14.5C13.0814 15.0014 12.75 15.712 12.75 16.5C12.75 18.0188 13.9812 19.25 15.5 19.25C16.288 19.25 16.9986 18.9186 17.5 18.3875M13.6125 14.5L17.5 18.3875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DocumentRejectedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 170 173"
      {...props}
    >
      <g filter="url(#a)">
        <path
          d="m80.273 6.691-68.482 30.7 1.812 4.042-1.812-4.043c-3.836 1.72-6.598 5.434-6.7 9.933-.234 10.29.117 39.107 10.072 65.531 4.994 13.257 12.511 26.199 23.857 35.849 11.436 9.727 26.482 15.864 45.98 15.864 19.498 0 34.544-6.137 45.98-15.864 11.346-9.65 18.863-22.592 23.857-35.849 9.955-26.424 10.306-55.24 10.072-65.53-.102-4.5-2.864-8.214-6.7-9.934L89.727 6.691a11.556 11.556 0 0 0-9.454 0Z"
          stroke="#C6B5F4"
          strokeWidth="9.905"
        />
      </g>
      <g filter="url(#b)">
        <path
          d="m82.299 11.21-68.483 30.7c-2.23 1-3.718 3.083-3.773 5.526C9.583 67.658 11.53 159.614 85 159.614s75.417-91.956 74.957-112.178c-.055-2.443-1.544-4.527-3.774-5.526l-68.482-30.7a6.604 6.604 0 0 0-5.402 0Z"
          fill="#F6F3FE"
        />
      </g>
      <path
        d="m71.111 103.773 27.778-26.6M71.648 76.634l26.703 27.678"
        stroke="#7431D2"
        strokeWidth="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="a"
          x=".094"
          y=".728"
          width="169.812"
          height="168.792"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="13.815" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.338929 0 0 0 0 0.57946 0 0 0 0.2 0" />
          <feBlend in2="shape" result="effect1_innerShadow_8188_3661" />
        </filter>
        <filter
          id="b"
          x="3.75"
          y="10.633"
          width="162.5"
          height="161.481"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.25" />
          <feGaussianBlur stdDeviation="3.125" />
          <feColorMatrix values="0 0 0 0 0.207843 0 0 0 0 0.101961 0 0 0 0 0.301961 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8188_3661"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_8188_3661"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const CheckCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#a)">
        <path
          d="M9.75 12.75 11 14.5l3.25-4.75"
          stroke="#fff"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="a"
          x="8.125"
          y="9.125"
          width="7.75"
          height="8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation=".5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6068_501"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6068_501"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const AccountablePawLogo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M14.7429 7.43588C14.3031 6.22856 13.154 5.45508 11.9214 5.45508C10.6889 5.45508 9.53979 6.22856 9.09997 7.43588L4.70107 19.5106C4.67116 19.5927 4.73201 19.6796 4.81946 19.6796H7.66958C7.76642 19.6796 7.85294 19.619 7.88605 19.5281L8.86722 16.8348C8.90033 16.7439 8.98684 16.6834 9.08369 16.6834H14.7592C14.856 16.6834 14.9425 16.7439 14.9756 16.8348L15.9568 19.5281C15.9899 19.619 16.0764 19.6796 16.1733 19.6796H19.0234C19.1108 19.6796 19.1717 19.5927 19.1418 19.5106L14.7429 7.43588ZM10.0755 13.5183L11.7706 8.86538C11.8218 8.72464 12.0211 8.72464 12.0723 8.86538L13.7674 13.5183C13.7973 13.6004 13.7365 13.6873 13.649 13.6873H10.1939C10.1064 13.6873 10.0456 13.6004 10.0755 13.5183Z"
        fill="currentColor"
      />
      <path
        d="M8.8515 0.101873C7.94603 0.443978 7.61916 1.54444 8.06513 2.40285C8.39301 3.03399 8.94842 3.46597 9.42917 3.74232C9.77003 3.93824 10.1 4.12914 10.275 4.2305C10.343 4.26985 10.4282 4.23883 10.455 4.16506C10.5238 3.975 10.6538 3.61686 10.7889 3.24787C11.0081 2.64878 11.1705 1.82816 10.8801 1.03121C10.5817 0.211921 9.67021 -0.207452 8.8515 0.101873Z"
        fill="currentColor"
      />
      <path
        d="M4.18964 4.03124C3.71625 4.8746 4.17374 5.92725 5.06744 6.29836C5.72451 6.5712 6.42775 6.54547 6.97369 6.44844C7.36074 6.37965 7.73622 6.31396 7.93548 6.27925C8.01282 6.26575 8.0582 6.18725 8.03121 6.11358C7.96171 5.9238 7.83087 5.56608 7.69698 5.19681C7.47955 4.59722 7.07605 3.86452 6.34108 3.44056C5.58548 3.00472 4.61767 3.26871 4.18964 4.03124Z"
        fill="currentColor"
      />
      <path
        d="M14.9503 0.0875486C14.0366 -0.231847 13.0782 0.401204 12.8675 1.34519C12.7126 2.03922 12.8602 2.72683 13.0506 3.24726C13.1857 3.61623 13.3157 3.9744 13.3845 4.16444C13.4113 4.2382 13.4965 4.2692 13.5645 4.22987C13.7395 4.12851 14.0695 3.93762 14.4103 3.74169C14.9637 3.42358 15.6161 2.89922 15.9064 2.10226C16.2049 1.28295 15.7765 0.376354 14.9503 0.0875486Z"
        fill="currentColor"
      />
      <path
        d="M19.6321 3.99573C19.1378 3.16446 17.9966 3.03394 17.228 3.62167C16.663 4.05378 16.3337 4.6751 16.1448 5.19599C16.0109 5.56526 15.8801 5.923 15.8106 6.11278C15.7836 6.18645 15.829 6.26495 15.9063 6.27845C16.1056 6.31319 16.4811 6.37888 16.8681 6.44766C17.4966 6.55935 18.3335 6.57657 19.0685 6.15261C19.8241 5.71677 20.0791 4.74736 19.6321 3.99573Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FilePlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1 1 22 22"
      fill="none"
      strokeWidth="1.5"
      {...props}
    >
      <path
        d="M11.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V6.75C5.75 5.64543 6.64543 4.75 7.75 4.75H14L18.25 9V11.25M17 14.75V19.25M19.25 17H14.75M18 9.25H13.75V5"
        stroke="currentColor"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PinIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M18.25 11C18.25 15 12 19.25 12 19.25C12 19.25 5.75 15 5.75 11C5.75 7.5 8.68629 4.75 12 4.75C15.3137 4.75 18.25 7.5 18.25 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 11C14.25 12.2426 13.2426 13.25 12 13.25C10.7574 13.25 9.75 12.2426 9.75 11C9.75 9.75736 10.7574 8.75 12 8.75C13.2426 8.75 14.25 9.75736 14.25 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MailboxIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M11.2499 15.25V8C11.2499 6.20507 9.7948 4.75 7.99988 4.75C6.20495 4.75 4.74988 6.20507 4.74988 8V15.25C4.74988 15.8023 5.19759 16.25 5.74988 16.25H10.2499C10.8022 16.25 11.2499 15.8023 11.2499 15.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49994 9C8.49994 9.27614 8.27608 9.5 7.99994 9.5C7.7238 9.5 7.49994 9.27614 7.49994 9C7.49994 8.72386 7.7238 8.5 7.99994 8.5C8.27608 8.5 8.49994 8.72386 8.49994 9Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M8.74994 4.75H15.2499C17.4591 4.75 19.2499 6.54086 19.2499 8.75V15.25C19.2499 15.8023 18.8022 16.25 18.2499 16.25H8.74994"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7499 9H16.2499"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9999 16.5V15.75H14.4999V16.5H15.9999ZM14.4999 19.25C14.4999 19.6642 14.8357 20 15.2499 20C15.6642 20 15.9999 19.6642 15.9999 19.25H14.4999ZM14.4999 16.5V19.25H15.9999V16.5H14.4999Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DataTableIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M2.30017 10.374V7.34158L13.4 7.36296L18.3286 7.34158V10.374V13.8396V16.1052C18.3286 16.7679 17.7913 17.3052 17.1286 17.3052H13.4H3.50017C2.83743 17.3052 2.30017 16.7679 2.30017 16.1052V13.8396V10.374Z"
        fill="#fff"
      />
      <path
        d="M4.03297 3.87613H16.5958C17.5528 3.87613 18.3286 4.65193 18.3286 5.60893V7.34173H14.863H10.3144H2.30017V5.60893C2.30017 4.65193 3.07597 3.87613 4.03297 3.87613Z"
        fill="currentColor"
      />
      <path
        d="M17.8783 14.2898H13.7631C13.7726 15.0296 13.7861 15.6256 13.8002 16.0847C13.8101 16.4089 13.8212 16.665 13.8295 16.8553H16.5961C17.3044 16.8551 17.8783 16.2804 17.8783 15.5721V14.2898ZM2.75037 13.3894H12.8539C12.8517 13.0564 12.85 12.7008 12.85 12.323C12.85 11.7759 12.8535 11.2767 12.8578 10.824H2.75037V13.3894ZM13.8285 7.81131C13.8202 7.99947 13.81 8.25266 13.8002 8.57303C13.789 8.93552 13.7788 9.38438 13.7699 9.92361H17.8783V7.79373L13.8285 7.81131ZM2.75037 9.92361H12.8695C12.8785 9.37343 12.8884 8.91496 12.8998 8.54471C12.9091 8.24288 12.9191 7.9995 12.9271 7.81229L2.75037 7.79178V9.92361ZM2.75037 15.5721C2.75037 16.2804 3.3243 16.8551 4.03259 16.8553H12.9281C12.92 16.6657 12.9092 16.4185 12.8998 16.1121C12.8855 15.6451 12.8723 15.04 12.8627 14.2898H2.75037V15.5721ZM17.8783 5.47147C17.8782 4.8037 17.3702 4.26899 16.7191 4.2449C15.4728 4.1988 13.4178 4.15018 10.3148 4.15018C7.21158 4.15018 5.15588 4.1988 3.90955 4.2449C3.25847 4.269 2.75043 4.80371 2.75037 5.47147V6.89139L13.3978 6.9119L17.8783 6.89334V5.47147ZM13.7543 13.3894H17.8783V10.824H13.7582C13.7539 11.276 13.7504 11.7752 13.7504 12.323C13.7504 12.7011 13.7521 13.0567 13.7543 13.3894ZM18.7787 15.5721C18.7787 16.7775 17.8015 17.7555 16.5961 17.7556H4.03259C2.82724 17.7554 1.84998 16.7775 1.84998 15.5721V5.47147C1.85004 4.33593 2.72532 3.38807 3.87634 3.34549C5.13543 3.29892 7.20233 3.24979 10.3148 3.24979C13.427 3.24979 15.4933 3.29891 16.7523 3.34549C17.9033 3.38807 18.7786 4.33593 18.7787 5.47147V15.5721Z"
        fill="#1B1B1B"
      />
      <path
        d="M5.60022 13.3755V10.3431L16.7 10.3645L21.6286 10.3431V13.3755V16.8411V19.1067C21.6286 19.7695 21.0914 20.3067 20.4286 20.3067H16.7H6.80022C6.13748 20.3067 5.60022 19.7695 5.60022 19.1067V16.8411V13.3755Z"
        fill="#fff"
      />
      <path
        d="M7.33302 6.87766H19.8958C20.8528 6.87766 21.6286 7.65346 21.6286 8.61046V10.3433H18.163H13.6144H5.60022V8.61046C5.60022 7.65346 6.37602 6.87766 7.33302 6.87766Z"
        fill="currentColor"
      />
      <path
        d="M21.1783 17.2914H17.0631C17.0727 18.0311 17.0862 18.6271 17.1002 19.0863C17.1101 19.4105 17.1212 19.6665 17.1295 19.8568H19.8961C20.6045 19.8566 21.1783 19.2819 21.1783 18.5736V17.2914ZM6.05042 16.391H16.1539C16.1518 16.0579 16.15 15.7024 16.15 15.3246C16.15 14.7774 16.1536 14.2782 16.1578 13.8255H6.05042V16.391ZM17.1285 10.8128C17.1203 11.001 17.1101 11.2542 17.1002 11.5746C17.0891 11.937 17.0789 12.3859 17.0699 12.9251H21.1783V10.7953L17.1285 10.8128ZM6.05042 12.9251H16.1696C16.1786 12.375 16.1884 11.9165 16.1998 11.5462C16.2091 11.2444 16.2191 11.001 16.2272 10.8138L6.05042 10.7933V12.9251ZM6.05042 18.5736C6.05042 19.2819 6.62434 19.8566 7.33264 19.8568H16.2281C16.22 19.6672 16.2092 19.42 16.1998 19.1136C16.1855 18.6466 16.1724 18.0416 16.1627 17.2914H6.05042V18.5736ZM21.1783 8.47299C21.1783 7.80522 20.6702 7.27052 20.0192 7.24643C18.7729 7.20033 16.7178 7.1517 13.6149 7.1517C10.5116 7.15171 8.45593 7.20033 7.20959 7.24643C6.55852 7.27052 6.05048 7.80523 6.05042 8.47299V9.89291L16.6979 9.91342L21.1783 9.89487V8.47299ZM17.0543 16.391H21.1783V13.8255H17.0582C17.0539 14.2776 17.0504 14.7767 17.0504 15.3246C17.0504 15.7027 17.0521 16.0582 17.0543 16.391ZM22.0787 18.5736C22.0787 19.779 21.1015 20.757 19.8961 20.7572H7.33264C6.12729 20.757 5.15002 19.779 5.15002 18.5736V8.47299C5.15009 7.33745 6.02537 6.38959 7.17639 6.34702C8.43548 6.30044 10.5024 6.25132 13.6149 6.25131C16.727 6.25131 18.7933 6.30044 20.0524 6.34702C21.2034 6.3896 22.0787 7.33745 22.0787 8.47299V18.5736Z"
        fill="#1B1B1B"
      />
    </svg>
  );
};

export const PlusCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.75V15.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.25 12L8.75 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MinusCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.25 12L8.75 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LockClosedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.75 11.75C5.75 11.1977 6.19772 10.75 6.75 10.75H17.25C17.8023 10.75 18.25 11.1977 18.25 11.75V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V11.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75001 10.5V10.3427C7.75001 8.78147 7.65609 7.04125 8.74648 5.9239C9.3683 5.2867 10.3745 4.75 12 4.75C13.6255 4.75 14.6317 5.2867 15.2536 5.9239C16.3439 7.04125 16.25 8.78147 16.25 10.3427V10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LightBulbShineIcon = (
  props: SVGProps<SVGSVGElement> & {
    fillColor1?: string;
    fillColor2?: string;
    fillColor3?: string;
  },
) => {
  const {
    fillColor1 = '#F6F3FE',
    fillColor2 = '#291547',
    fillColor3 = '#C6B5F4',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M8.24268 16.4423C4.69148 15.6006 4.33951 5.7998 12.1395 5.7998C20.2794 5.7998 18.8818 15.6124 15.2359 16.4438C14.9667 16.5052 14.7395 16.7237 14.7395 16.9998V18.4998C15.3145 18.8448 15.8235 19.6188 15.2396 20.2994C15.4063 21.6662 15.807 23.2998 11.7396 23.2998C8.11743 23.2998 7.86281 21.3998 8.42443 20.3998C7.7337 19.6999 8.30279 18.843 8.73953 18.4998V16.9997C8.73953 16.7235 8.51138 16.506 8.24268 16.4423Z"
        fill={fillColor1}
      />
      <path
        d="M14.2897 17C14.2897 16.4569 14.7238 16.099 15.1364 16.0049C15.8655 15.8386 16.5486 15.2016 17.0329 14.2295C17.5121 13.2676 17.7592 12.0454 17.6598 10.8477C17.5606 9.65222 17.1193 8.50938 16.2565 7.66797C15.3989 6.83176 14.0806 6.25003 12.1403 6.25C10.2909 6.25 8.96295 6.82785 8.04655 7.6748C7.12432 8.5272 6.58671 9.68208 6.37858 10.8818C6.17005 12.0844 6.29776 13.3045 6.67546 14.2588C7.05705 15.2229 7.65828 15.8416 8.34733 16.0049C8.75382 16.1013 9.19011 16.4553 9.19011 17V17.7822C9.39962 17.7144 9.62415 17.6617 9.85124 17.6211C10.4012 17.5228 11.0368 17.4809 11.6696 17.4873C12.3032 17.4938 12.9472 17.5483 13.5153 17.6484C13.7859 17.6961 14.0485 17.7568 14.2897 17.8301V17ZM14.8581 21.0312C14.5846 21.1239 14.2646 21.1887 13.9294 21.2344C13.2577 21.3258 12.4658 21.3496 11.7399 21.3496C11.0456 21.3496 10.3063 21.339 9.67937 21.2676C9.36571 21.2319 9.06512 21.1789 8.80534 21.0996C8.75897 21.0855 8.71312 21.0678 8.66667 21.0508C8.61569 21.35 8.66588 21.6752 8.87468 21.9561C9.19624 22.3884 9.98809 22.8496 11.7399 22.8496C13.76 22.8496 14.4546 22.4341 14.7038 22.0615C14.8303 21.8722 14.8832 21.6386 14.8854 21.3418C14.8862 21.2378 14.8797 21.1328 14.8708 21.0254C14.8664 21.0269 14.8625 21.0298 14.8581 21.0312ZM11.6608 18.3877C11.0688 18.3817 10.4916 18.4208 10.0104 18.5068C9.51124 18.5961 9.17958 18.7248 9.02116 18.8516L9.01823 18.8535C8.85352 18.9829 8.66575 19.2127 8.58855 19.4531C8.52122 19.6631 8.53535 19.8708 8.74577 20.084C8.78099 20.1195 8.87367 20.1799 9.06804 20.2393C9.25487 20.2963 9.4954 20.3405 9.78093 20.373C10.3521 20.4381 11.0459 20.4502 11.7399 20.4502C12.4538 20.4502 13.1969 20.4258 13.8073 20.3428C14.1127 20.3012 14.3709 20.2467 14.569 20.1797C14.7775 20.1091 14.8696 20.0412 14.8991 20.0068C15.0725 19.8047 15.0766 19.62 15.0055 19.4385C14.9235 19.2293 14.7317 19.02 14.5104 18.8867C14.2792 18.7528 13.8805 18.6271 13.3591 18.5352C12.846 18.4447 12.2521 18.3937 11.6608 18.3877ZM15.1901 18.2646C15.4621 18.476 15.7089 18.7663 15.8434 19.1094C16.0035 19.5176 15.9959 19.9885 15.7087 20.4229C15.7452 20.7063 15.7881 21.0338 15.7858 21.3486C15.7829 21.7422 15.7125 22.1728 15.4518 22.5625C14.9262 23.3482 13.787 23.75 11.7399 23.75C9.87003 23.7499 8.72383 23.2607 8.153 22.4932C7.6598 21.83 7.66913 21.0588 7.89909 20.4639C7.61516 20.0395 7.60328 19.5775 7.73112 19.1787C7.84519 18.8231 8.06732 18.517 8.28972 18.2988V17C8.28972 16.9922 8.28826 16.975 8.26433 16.9492C8.23775 16.9208 8.19278 16.8926 8.13933 16.8799C7.05293 16.6223 6.27793 15.7 5.83855 14.5898C5.39528 13.4698 5.2573 12.0813 5.49187 10.7285C5.72691 9.37308 6.34186 8.0251 7.4362 7.01367C8.53657 5.99682 10.0899 5.34961 12.1403 5.34961C14.2695 5.34964 15.8287 5.99415 16.8844 7.02344C17.9349 8.04779 18.4432 9.41093 18.5563 10.7725C18.6692 12.1317 18.3924 13.5192 17.8385 14.6309C17.2898 15.7323 16.4303 16.6334 15.3366 16.8828C15.2853 16.8945 15.2424 16.9206 15.2165 16.9482C15.1927 16.9737 15.1901 16.9914 15.1901 17V18.2646Z"
        fill={fillColor2}
      />
      <path
        d="M8.741 18.4997C9.74105 17.6996 13.5411 17.7996 14.7409 18.4997C15.316 18.8447 15.8249 19.6187 15.2411 20.2993C15.4077 21.6661 15.8085 23.2996 11.7411 23.2996C8.1189 23.2996 7.86428 21.3996 8.42589 20.3996C7.73516 19.6997 8.30426 18.8428 8.741 18.4997Z"
        fill={fillColor3}
      />
      <path
        d="M11.6706 17.4879C12.304 17.4944 12.9474 17.549 13.5153 17.6491C14.0031 17.7351 14.4665 17.8598 14.822 18.0338L14.9675 18.112L14.9724 18.1139C15.3254 18.3257 15.6744 18.6764 15.8444 19.11C16.0045 19.5183 15.9961 19.9891 15.7087 20.4235C15.7453 20.7069 15.7881 21.0336 15.7858 21.3483C15.7829 21.742 15.7136 22.1733 15.4528 22.5631C14.9272 23.3489 13.788 23.7506 11.7409 23.7506C9.87081 23.7506 8.72388 23.2614 8.15302 22.4938C7.6598 21.8305 7.67099 21.0595 7.90107 20.4645C7.61663 20.0399 7.6042 19.5784 7.73212 19.1794C7.87604 18.7306 8.19065 18.3598 8.46259 18.1462C8.80424 17.8744 9.3218 17.7166 9.85224 17.6217C10.4022 17.5234 11.0378 17.4815 11.6706 17.4879ZM14.8591 21.0319C14.5855 21.1245 14.2648 21.1894 13.9294 21.235C13.2579 21.3264 12.4667 21.3503 11.7409 21.3503C11.0464 21.3503 10.3065 21.3387 9.67939 21.2672C9.36592 21.2315 9.066 21.1795 8.80634 21.1003C8.75978 21.086 8.71333 21.0685 8.66669 21.0514C8.61578 21.3506 8.66681 21.6758 8.87568 21.9567C9.19733 22.3891 9.98904 22.8503 11.7409 22.8503C13.7609 22.8502 14.4556 22.4348 14.7048 22.0622C14.8312 21.8729 14.8842 21.6391 14.8864 21.3424C14.8872 21.2388 14.8797 21.134 14.8708 21.027C14.8668 21.0284 14.8631 21.0305 14.8591 21.0319ZM11.6608 18.3874C11.0688 18.3813 10.4917 18.4214 10.0104 18.5075C9.51181 18.5966 9.18074 18.7246 9.02216 18.8512L9.01826 18.8542C8.85355 18.9837 8.66567 19.2134 8.58857 19.4538C8.52124 19.6637 8.53537 19.8714 8.7458 20.0846C8.78091 20.1201 8.8743 20.1805 9.06904 20.2399C9.25573 20.2968 9.49579 20.3412 9.78095 20.3737C10.3522 20.4387 11.0467 20.4499 11.7409 20.4499C12.4549 20.4499 13.1978 20.4255 13.8083 20.3424C14.1139 20.3009 14.3719 20.2465 14.57 20.1794C14.7785 20.1087 14.8696 20.0409 14.8991 20.0065C15.0725 19.8043 15.0777 19.6197 15.0065 19.4381C14.9244 19.2289 14.7318 19.0206 14.5104 18.8874C14.2792 18.7535 13.8804 18.6277 13.3591 18.5358C12.8461 18.4454 12.2521 18.3934 11.6608 18.3874Z"
        fill={fillColor2}
      />
      <path
        d="M12.2393 8.0498C12.9029 8.0498 13.8616 8.27335 14.5508 8.9873C15.2659 9.72816 15.6024 10.9028 15.1758 12.6094C15.1154 12.8503 14.8709 12.9968 14.6299 12.9365C14.3889 12.8761 14.2425 12.6317 14.3027 12.3906C14.676 10.8974 14.3465 10.0714 13.9033 9.6123C13.4342 9.12626 12.7423 8.9502 12.2393 8.9502C11.9907 8.9502 11.7891 8.74853 11.7891 8.5C11.7891 8.25147 11.9907 8.0498 12.2393 8.0498Z"
        fill="white"
      />
      <path
        d="M3.80078 11.75C4.04925 11.7501 4.25098 11.9517 4.25098 12.2002C4.25098 12.4487 4.04925 12.6503 3.80078 12.6504H1.60059C1.35206 12.6504 1.15039 12.4487 1.15039 12.2002C1.15039 11.9517 1.35206 11.75 1.60059 11.75H3.80078Z"
        fill={fillColor2}
      />
      <path
        d="M19.7496 4.07581C19.9564 3.93799 20.2358 3.9932 20.3737 4.19984C20.5115 4.40656 20.4553 4.68596 20.2487 4.82386L18.1491 6.22425C17.9423 6.3621 17.6629 6.306 17.525 6.09925C17.3872 5.89252 17.4424 5.61313 17.6491 5.47523L19.7496 4.07581Z"
        fill={fillColor2}
      />
      <path
        d="M3.12651 4.19975C3.26447 3.99333 3.5439 3.93797 3.75053 4.07573L5.85014 5.47514C6.05685 5.61295 6.11281 5.8924 5.97514 6.09917C5.83731 6.30591 5.55789 6.36191 5.35112 6.22417L3.25053 4.82378C3.04412 4.68581 2.98875 4.40639 3.12651 4.19975Z"
        fill={fillColor2}
      />
      <path
        d="M22.5 11.75C22.7485 11.7501 22.9502 11.9517 22.9502 12.2002C22.9502 12.4487 22.7485 12.6503 22.5 12.6504H20.2998C20.0513 12.6504 19.8496 12.4487 19.8496 12.2002C19.8496 11.9517 20.0513 11.75 20.2998 11.75H22.5Z"
        fill={fillColor2}
      />
      <path
        d="M11.5508 3.7002V1.2998C11.5508 1.05128 11.7524 0.849609 12.001 0.849609C12.2495 0.849609 12.4512 1.05128 12.4512 1.2998V3.7002C12.451 3.94854 12.2494 4.14941 12.001 4.14941C11.7526 4.14941 11.551 3.94854 11.5508 3.7002Z"
        fill={fillColor2}
      />
    </svg>
  );
};

export const AvatarIcon = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill="currentColor"
      />
      <g clipPath={`url(#${id})`}>
        <ellipse
          cx="16"
          cy="31.2"
          rx="12.8"
          ry="9.6"
          fill="white"
          fillOpacity="0.72"
        />
        <circle opacity="0.9" cx="16.0001" cy="12.8" r="6.4" fill="white" />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="32" height="32" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProfileUserApprovedIcon = (
  props: SVGProps<SVGSVGElement> & {
    fillColor1?: string;
    fillColor2?: string;
    fillColor3?: string;
  },
) => {
  const {
    fillColor1 = '#291547',
    fillColor2 = '#F6F3FE',
    fillColor3 = '#C6B5F4',
  } = props;
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M1.16386 13.771L1.98275 3.7554C2.10659 2.2407 3.34355 1.05788 4.86227 1.0019L18.2169 0.50968C18.4043 0.502774 18.5919 0.513451 18.7773 0.541572L19.2657 0.615652C20.7251 0.837012 21.8066 2.08706 21.8158 3.56309L21.881 14.067C21.8914 15.7367 20.5365 17.0935 18.8668 17.0856L4.1396 17.0155C2.39203 17.0071 1.02145 15.5128 1.16386 13.771Z"
          fill={fillColor1}
        />
        <path
          d="M18.3618 0.0578918C18.5234 0.0595008 18.6852 0.0726893 18.8452 0.0969543L19.3335 0.171173L19.643 0.23172C21.1623 0.605696 22.256 1.9688 22.2661 3.55984L22.3305 14.0638L22.3276 14.2434C22.2477 16.0213 20.8212 17.4493 19.0434 17.5315L18.8647 17.5354L4.13717 17.4651C2.12771 17.4554 0.551705 15.7375 0.71529 13.7346L1.53463 3.71902L1.55123 3.55692C1.76565 1.89324 3.15408 0.614398 4.84615 0.552032L18.2006 0.059845L18.3618 0.0578918ZM4.87838 1.45145C3.66843 1.49626 2.6694 2.38275 2.46236 3.55399L2.43111 3.79227L1.61275 13.8079C1.4918 15.2883 2.65667 16.5586 4.14205 16.5657L18.8686 16.636L19.1313 16.6233C20.3411 16.5056 21.3033 15.5422 21.4194 14.3323L21.4311 14.0696L21.3657 3.5657C21.3583 2.38965 20.5502 1.38217 19.4272 1.10574L19.1987 1.06082L18.7094 0.986603C18.5521 0.962762 18.3929 0.953418 18.2338 0.959259L4.87838 1.45145Z"
          fill={fillColor1}
        />
        <path
          d="M1 13.5V3.5C1 1.84315 2.34315 0.5 4 0.5H18.1C19.7568 0.5 21.1 1.84315 21.1 3.5V13.5C21.1 15.1569 19.7568 16.5 18.1 16.5H4C2.34315 16.5 1 15.1569 1 13.5Z"
          fill={fillColor2}
        />
        <path
          d="M7.49976 11.8994C9.11274 11.8994 10.3641 12.5636 11.2087 13.4404C12.0398 14.3032 12.4998 15.3976 12.4998 16.2998H11.4998C11.4998 15.702 11.175 14.846 10.489 14.1338C9.81655 13.4356 8.81837 12.8994 7.49976 12.8994C4.83627 12.8994 3.49976 14.7505 3.49976 16.2998H2.49976C2.49976 14.1824 4.29999 11.8994 7.49976 11.8994Z"
          fill={fillColor1}
        />
        <path
          d="M9.39929 8.30046C9.39929 7.5134 9.14256 7.01762 8.8114 6.71257C8.46807 6.39637 7.95214 6.20085 7.29968 6.20085C6.13988 6.20085 5.20007 7.14066 5.20007 8.30046C5.20007 9.46026 6.13988 10.4001 7.29968 10.4001V11.3005C5.64283 11.3005 4.29968 9.95731 4.29968 8.30046C4.29968 6.64361 5.64283 5.30046 7.29968 5.30046C8.95654 5.30046 10.2997 6.30046 10.2997 8.30046C10.2997 10.3005 8.95654 11.3005 7.29968 11.3005V10.4001C7.95214 10.4001 8.46807 10.2046 8.8114 9.88835C9.14256 9.5833 9.39929 9.08752 9.39929 8.30046Z"
          fill={fillColor1}
        />
        <path
          d="M20.6504 3.5C20.6504 2.09167 19.5079 0.950195 18.0996 0.950195H4C2.59167 0.950197 1.4502 2.09168 1.4502 3.5V13.5C1.4502 14.9083 2.59167 16.0498 4 16.0498H18.0996C19.5079 16.0498 20.6504 14.9083 20.6504 13.5V3.5ZM21.5498 13.5C21.5498 15.4054 20.005 16.9502 18.0996 16.9502H4C2.09462 16.9502 0.549805 15.4054 0.549805 13.5V3.5C0.549805 1.59462 2.09462 0.049806 4 0.0498047H18.0996C20.005 0.0498047 21.5498 1.59462 21.5498 3.5V13.5Z"
          fill={fillColor1}
        />
        <path
          d="M15.8995 4.24982C16.6097 4.24982 17.0738 4.27508 17.3653 4.30157C17.5112 4.31484 17.6152 4.32853 17.6856 4.33966C17.7206 4.34519 17.7476 4.3503 17.7677 4.35431C17.7777 4.35631 17.7863 4.35866 17.7931 4.36017C17.7963 4.3609 17.7993 4.36152 17.8018 4.36212C17.8031 4.36243 17.8046 4.36283 17.8058 4.3631H17.8087L17.8946 4.39435C18.0834 4.48479 18.1885 4.69806 18.1358 4.909C18.0755 5.14997 17.8319 5.29626 17.5909 5.23615L17.545 5.22931C17.4968 5.22169 17.4131 5.20978 17.2843 5.19806C17.0259 5.17457 16.5895 5.15021 15.8995 5.15021C15.21 5.15021 14.7741 5.17458 14.5157 5.19806C14.3867 5.20979 14.3022 5.22169 14.254 5.22931C14.2304 5.23303 14.2154 5.23469 14.2081 5.23615H14.2091C13.968 5.29648 13.7235 5.15009 13.6632 4.909C13.603 4.66799 13.7493 4.42343 13.9903 4.3631H13.9933C13.9944 4.36283 13.9959 4.36242 13.9972 4.36212C13.9997 4.36152 14.0027 4.3609 14.006 4.36017C14.0127 4.35866 14.0213 4.35632 14.0313 4.35431C14.0514 4.3503 14.0783 4.3452 14.1134 4.33966C14.1838 4.32854 14.2878 4.31484 14.4337 4.30157C14.7252 4.27507 15.1892 4.24982 15.8995 4.24982ZM17.5948 5.23712C17.5958 5.23736 17.5967 5.23807 17.5968 5.2381L17.5919 5.23712H17.5948Z"
          fill={fillColor1}
        />
        <path
          d="M15.8999 6.94916C17.1049 6.94952 17.7914 6.97508 18.1802 7.00092C18.3743 7.01382 18.4985 7.02664 18.5786 7.03803C18.6189 7.04376 18.6505 7.0494 18.6753 7.05463C18.6876 7.05723 18.699 7.0597 18.7095 7.06244C18.7147 7.06381 18.72 7.06584 18.7251 7.06733C18.7276 7.06804 18.7305 7.06852 18.7329 7.06928C18.7342 7.06969 18.7365 7.07081 18.7378 7.07123H18.7398L18.7407 7.07221C18.7404 7.07467 18.7321 7.10124 18.6333 7.39936L18.7417 7.07221C18.9773 7.15051 19.1048 7.40488 19.0269 7.64057C18.949 7.87546 18.6965 8.0028 18.4615 7.9267L18.4624 7.92768C18.4634 7.928 18.4644 7.92836 18.4654 7.92865C18.4677 7.92937 18.4702 7.93003 18.4722 7.93061C18.4761 7.93175 18.4794 7.93286 18.482 7.93354C18.4867 7.93478 18.4898 7.93549 18.4898 7.93549C18.4888 7.93528 18.477 7.93322 18.4517 7.92963C18.4006 7.92239 18.2997 7.91034 18.1197 7.89838C17.7586 7.8744 17.0947 7.84991 15.8999 7.84955C14.7046 7.8492 14.04 7.87424 13.6792 7.89838C13.4993 7.91043 13.3989 7.92136 13.3482 7.92865C13.323 7.93227 13.3119 7.93532 13.3111 7.93549C13.3111 7.93549 13.3141 7.93481 13.3189 7.93354C13.3214 7.93286 13.3248 7.93173 13.3286 7.93061C13.3306 7.93003 13.3332 7.92937 13.3355 7.92865C13.3366 7.92828 13.3381 7.92809 13.3394 7.92768L13.3413 7.9267H13.3423L13.3413 7.92572C13.1062 8.00383 12.852 7.87757 12.773 7.64252C12.694 7.40711 12.8209 7.15245 13.0562 7.07318L13.1997 7.49897C13.0585 7.07899 13.0567 7.07246 13.0572 7.07221H13.0581L13.0601 7.07123C13.0613 7.07083 13.0628 7.07064 13.064 7.07026C13.0665 7.06945 13.0693 7.06808 13.0718 7.06733C13.0771 7.06576 13.083 7.06486 13.0884 7.06342C13.0992 7.06057 13.111 7.05732 13.1236 7.05463C13.1485 7.04932 13.18 7.04381 13.2202 7.03803C13.3007 7.02647 13.4253 7.01295 13.6197 6.99994C14.0088 6.97391 14.6949 6.94881 15.8999 6.94916Z"
          fill={fillColor1}
        />
        <path
          d="M13.6239 19.9483C12.124 16.4483 14.124 13.9483 16.124 12.9483C20.124 11.4483 22.9239 13.9483 23.4239 16.9483C23.924 19.9483 21.7572 21.9483 20.4239 22.4483C18.9239 22.9483 14.9793 23.111 13.6239 19.9483Z"
          fill={fillColor3}
        />
        <path
          d="M16.3599 12.3906C18.3143 11.7668 20.0224 12.0415 21.3297 12.8827C22.7115 13.772 23.5994 15.2646 23.8677 16.874C24.1395 18.5045 23.6846 19.8716 22.982 20.8915C22.2873 21.8999 21.3396 22.5858 20.5816 22.8701L20.5738 22.873L20.566 22.8749C19.7429 23.1493 18.2994 23.3218 16.8736 23.0117C15.5236 22.7179 14.1448 21.9787 13.3589 20.4433L13.2105 20.1259C12.4119 18.2624 12.5348 16.6272 13.1548 15.3183C13.7678 14.0243 14.8493 13.0825 15.9224 12.5458L15.9439 12.5351L16.3599 12.3906ZM20.8433 13.6396C19.7168 12.9146 18.1744 12.6661 16.3023 13.3622C15.3834 13.8274 14.4762 14.6313 13.9683 15.7031C13.4633 16.7691 13.3364 18.135 14.0377 19.7714L14.1578 20.0273C14.7896 21.2644 15.897 21.8776 17.065 22.1318C18.3215 22.4051 19.5964 22.247 20.275 22.0224C20.8495 21.8041 21.6472 21.2424 22.2408 20.3808C22.8298 19.5257 23.2083 18.3918 22.98 17.0224C22.7483 15.632 21.9861 14.3753 20.8433 13.6396Z"
          fill={fillColor1}
        />
        <path
          d="M20.1318 15.1319C20.3076 14.9561 20.5928 14.9561 20.7686 15.1319C20.9443 15.3076 20.9443 15.5929 20.7686 15.7686C20.7681 15.7691 20.7527 15.785 20.7168 15.8291C20.6837 15.8698 20.6413 15.9245 20.5898 15.9913C20.4869 16.1247 20.3536 16.3021 20.2002 16.5088C19.8937 16.9219 19.5104 17.4465 19.1357 17.9639C18.7612 18.4811 18.3961 18.99 18.124 19.3692C17.9881 19.5585 17.8754 19.7155 17.7969 19.8252C17.7576 19.8801 17.726 19.9239 17.7051 19.9532C17.6948 19.9676 17.687 19.9789 17.6816 19.9864C17.6792 19.9898 17.6771 19.9923 17.6758 19.9942L17.6738 19.9971C17.597 20.1047 17.4765 20.1736 17.3447 20.1846C17.2458 20.1928 17.1477 20.1677 17.0654 20.1153L16.9893 20.0538H16.9883L16.9805 20.0459C16.9766 20.042 16.9717 20.0366 16.9658 20.0303C16.9541 20.0178 16.9389 20.0002 16.9199 19.9786C16.8817 19.9349 16.8293 19.873 16.7686 19.792C16.6471 19.6301 16.4893 19.3926 16.333 19.0801C16.1767 18.7675 16.0941 18.522 16.0498 18.3448C16.0277 18.2563 16.0146 18.1849 16.0078 18.1309C16.0045 18.1042 16.0031 18.0817 16.002 18.0635C16.0014 18.0544 16.0002 18.046 16 18.0391V18.0225C16 18.0223 16.0002 18.0215 16.4502 18.0215H16C16.0001 17.7731 16.2017 17.5713 16.4502 17.5713C16.6675 17.5713 16.8485 17.7258 16.8906 17.9307L16.9004 18.0215V18.0108L16.9014 18.0196C16.9036 18.037 16.9093 18.0729 16.9229 18.127C16.95 18.2355 17.0094 18.4192 17.1387 18.6778C17.1937 18.7877 17.2489 18.8852 17.3008 18.9707C17.3298 18.9303 17.3609 18.888 17.3926 18.8438C17.6651 18.4641 18.0318 17.955 18.4072 17.4366C18.7825 16.9183 19.168 16.39 19.4775 15.9727C19.6322 15.7642 19.769 15.5814 19.877 15.4414C19.976 15.313 20.0711 15.1926 20.1318 15.1319ZM17.625 19.418C17.6259 19.419 17.6267 19.4197 17.627 19.42V19.419L17.626 19.418H17.625Z"
          fill={fillColor1}
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProfileUserClockIcon = (
  props: SVGProps<SVGSVGElement> & {
    fillColor1?: string;
    fillColor2?: string;
    fillColor3?: string;
  },
) => {
  const {
    fillColor1 = '#291547',
    fillColor2 = '#F6F3FE',
    fillColor3 = '#C6B5F4',
  } = props;
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M1.1638 13.771L1.98269 3.75541C2.10653 2.24071 3.34349 1.05789 4.86221 1.00192L18.2169 0.509696C18.4043 0.502789 18.5919 0.513466 18.7773 0.541587L19.2657 0.615667C20.725 0.837027 21.8065 2.08708 21.8157 3.56311L21.881 14.067C21.8913 15.7367 20.5364 17.0936 18.8667 17.0856L4.13954 17.0155C2.39197 17.0072 1.02139 15.5128 1.1638 13.771Z"
          fill={fillColor1}
        />
        <path
          d="M18.3617 0.0578918C18.5234 0.0595008 18.6851 0.0726893 18.8451 0.0969543L19.3334 0.171173L19.643 0.23172C21.1622 0.605696 22.2559 1.9688 22.266 3.55984L22.3305 14.0638L22.3275 14.2434C22.2477 16.0213 20.8211 17.4493 19.0434 17.5315L18.8646 17.5354L4.1371 17.4651C2.12765 17.4554 0.551644 15.7375 0.715229 13.7346L1.53456 3.71902L1.55117 3.55692C1.76559 1.89324 3.15401 0.614398 4.84609 0.552032L18.2006 0.059845L18.3617 0.0578918ZM4.87831 1.45145C3.66837 1.49626 2.66934 2.38275 2.4623 3.55399L2.43105 3.79227L1.61269 13.8079C1.49174 15.2883 2.65661 16.5586 4.14199 16.5657L18.8685 16.636L19.1312 16.6233C20.341 16.5056 21.3033 15.5422 21.4193 14.3323L21.431 14.0696L21.3656 3.5657C21.3582 2.38965 20.5501 1.38217 19.4271 1.10574L19.1986 1.06082L18.7094 0.986603C18.552 0.962762 18.3928 0.953418 18.2338 0.959259L4.87831 1.45145Z"
          fill={fillColor1}
        />
        <path
          d="M1 13.5V3.5C1 1.84315 2.34315 0.5 4 0.5H18.1C19.7568 0.5 21.1 1.84315 21.1 3.5V13.5C21.1 15.1569 19.7568 16.5 18.1 16.5H4C2.34315 16.5 1 15.1569 1 13.5Z"
          fill={fillColor2}
        />
        <path
          d="M7.49976 11.8994C9.11274 11.8994 10.3641 12.5636 11.2087 13.4404C12.0398 14.3032 12.4998 15.3976 12.4998 16.2998H11.4998C11.4998 15.702 11.175 14.846 10.489 14.1338C9.81655 13.4357 8.81837 12.8994 7.49976 12.8994C4.83627 12.8994 3.49976 14.7505 3.49976 16.2998H2.49976C2.49976 14.1824 4.29999 11.8994 7.49976 11.8994Z"
          fill={fillColor1}
        />
        <path
          d="M9.39929 8.30048C9.39929 7.51342 9.14256 7.01763 8.8114 6.71259C8.46807 6.39638 7.95214 6.20087 7.29968 6.20087C6.13988 6.20087 5.20007 7.14068 5.20007 8.30048C5.20007 9.46027 6.13988 10.4001 7.29968 10.4001V11.3005C5.64283 11.3005 4.29968 9.95733 4.29968 8.30048C4.29968 6.64362 5.64283 5.30048 7.29968 5.30048C8.95654 5.30048 10.2997 6.30048 10.2997 8.30048C10.2997 10.3005 8.95654 11.3005 7.29968 11.3005V10.4001C7.95214 10.4001 8.46807 10.2046 8.8114 9.88837C9.14256 9.58332 9.39929 9.08754 9.39929 8.30048Z"
          fill={fillColor1}
        />
        <path
          d="M20.6504 3.5C20.6504 2.09167 19.5079 0.950195 18.0996 0.950195H4C2.59167 0.950197 1.4502 2.09168 1.4502 3.5V13.5C1.4502 14.9083 2.59167 16.0498 4 16.0498H18.0996C19.5079 16.0498 20.6504 14.9083 20.6504 13.5V3.5ZM21.5498 13.5C21.5498 15.4054 20.005 16.9502 18.0996 16.9502H4C2.09462 16.9502 0.549805 15.4054 0.549805 13.5V3.5C0.549805 1.59462 2.09462 0.049806 4 0.0498047H18.0996C20.005 0.0498047 21.5498 1.59462 21.5498 3.5V13.5Z"
          fill={fillColor1}
        />
        <path
          d="M15.8995 4.24982C16.6097 4.24982 17.0738 4.27508 17.3653 4.30157C17.5112 4.31484 17.6152 4.32853 17.6856 4.33966C17.7206 4.34519 17.7476 4.3503 17.7677 4.35431C17.7777 4.35631 17.7863 4.35866 17.7931 4.36017C17.7963 4.3609 17.7993 4.36152 17.8018 4.36212C17.8031 4.36243 17.8046 4.36283 17.8058 4.3631H17.8087L17.8946 4.39435C18.0834 4.48479 18.1885 4.69806 18.1358 4.909C18.0755 5.14997 17.8319 5.29626 17.5909 5.23615L17.545 5.22931C17.4968 5.22169 17.4131 5.20978 17.2843 5.19806C17.0259 5.17457 16.5895 5.15021 15.8995 5.15021C15.21 5.15021 14.7741 5.17458 14.5157 5.19806C14.3867 5.20979 14.3022 5.22169 14.254 5.22931C14.2304 5.23303 14.2154 5.23469 14.2081 5.23615H14.2091C13.968 5.29648 13.7235 5.15009 13.6632 4.909C13.603 4.66799 13.7493 4.42343 13.9903 4.3631H13.9933C13.9944 4.36283 13.9959 4.36242 13.9972 4.36212C13.9997 4.36152 14.0027 4.3609 14.006 4.36017C14.0127 4.35866 14.0213 4.35632 14.0313 4.35431C14.0514 4.3503 14.0783 4.3452 14.1134 4.33966C14.1838 4.32854 14.2878 4.31484 14.4337 4.30157C14.7252 4.27507 15.1892 4.24982 15.8995 4.24982ZM17.5948 5.23712C17.5958 5.23736 17.5967 5.23807 17.5968 5.2381L17.5919 5.23712H17.5948Z"
          fill={fillColor1}
        />
        <path
          d="M15.8999 6.94916C17.1049 6.94952 17.7913 6.97508 18.1801 7.00092C18.3742 7.01382 18.4984 7.02664 18.5786 7.03803C18.6189 7.04376 18.6505 7.0494 18.6753 7.05463C18.6876 7.05723 18.6989 7.0597 18.7094 7.06244C18.7147 7.06381 18.72 7.06584 18.7251 7.06733C18.7275 7.06804 18.7304 7.06852 18.7329 7.06928C18.7342 7.06969 18.7364 7.07081 18.7378 7.07123H18.7397L18.7407 7.07221C18.7403 7.07467 18.732 7.10124 18.6333 7.39936L18.7417 7.07221C18.9772 7.15051 19.1047 7.40488 19.0268 7.64057C18.949 7.87546 18.6964 8.0028 18.4614 7.9267L18.4624 7.92768C18.4634 7.928 18.4643 7.92836 18.4653 7.92865C18.4676 7.92937 18.4702 7.93003 18.4721 7.93061C18.476 7.93175 18.4793 7.93286 18.4819 7.93354C18.4866 7.93478 18.4897 7.93549 18.4897 7.93549C18.4887 7.93528 18.4769 7.93322 18.4516 7.92963C18.4005 7.92239 18.2996 7.91034 18.1196 7.89838C17.7585 7.8744 17.0946 7.84991 15.8999 7.84955C14.7045 7.8492 14.04 7.87424 13.6792 7.89838C13.4992 7.91043 13.3989 7.92136 13.3481 7.92865C13.3229 7.93227 13.3118 7.93532 13.311 7.93549C13.311 7.93549 13.314 7.93481 13.3188 7.93354C13.3214 7.93286 13.3248 7.93173 13.3286 7.93061C13.3305 7.93003 13.3331 7.92937 13.3354 7.92865C13.3366 7.92828 13.3381 7.92809 13.3393 7.92768L13.3413 7.9267H13.3423L13.3413 7.92572C13.1061 8.00383 12.8519 7.87757 12.7729 7.64252C12.6939 7.40711 12.8208 7.15245 13.0561 7.07318L13.1997 7.49897C13.0585 7.07899 13.0566 7.07246 13.0571 7.07221H13.0581L13.06 7.07123C13.0613 7.07083 13.0627 7.07064 13.0639 7.07026C13.0665 7.06945 13.0692 7.06808 13.0717 7.06733C13.077 7.06576 13.0829 7.06486 13.0883 7.06342C13.0991 7.06057 13.1109 7.05732 13.1235 7.05463C13.1484 7.04932 13.18 7.04381 13.2202 7.03803C13.3006 7.02647 13.4252 7.01295 13.6196 6.99994C14.0087 6.97391 14.6949 6.94881 15.8999 6.94916Z"
          fill={fillColor1}
        />
        <path
          d="M13.6239 19.9483C12.124 16.4483 14.124 13.9483 16.124 12.9483C20.124 11.4483 22.9239 13.9483 23.4239 16.9483C23.924 19.9483 21.7572 21.9483 20.4239 22.4483C18.9239 22.9483 14.9793 23.111 13.6239 19.9483Z"
          fill={fillColor3}
        />
        <path
          d="M17.649 14.5989C17.649 14.3504 17.8507 14.1487 18.0992 14.1487C18.3478 14.1487 18.5494 14.3504 18.5494 14.5989V17.6487H21.0992C21.3478 17.6487 21.5494 17.8504 21.5494 18.0989C21.5494 18.3474 21.3478 18.5491 21.0992 18.5491H18.0992C17.8507 18.5491 17.649 18.3474 17.649 18.0989V14.5989Z"
          fill={fillColor1}
        />
        <path
          d="M16.3599 12.3906C18.3143 11.7668 20.0224 12.0415 21.3297 12.8827C22.7115 13.772 23.5994 15.2646 23.8677 16.874C24.1395 18.5045 23.6846 19.8716 22.982 20.8915C22.2873 21.8999 21.3396 22.5858 20.5816 22.8701L20.5738 22.873L20.566 22.8749C19.7429 23.1493 18.2994 23.3218 16.8736 23.0117C15.5236 22.7179 14.1448 21.9787 13.3589 20.4433L13.2105 20.1259C12.4119 18.2624 12.5348 16.6272 13.1548 15.3183C13.7678 14.0243 14.8493 13.0825 15.9224 12.5458L15.9439 12.5351L16.3599 12.3906ZM20.8433 13.6396C19.7168 12.9146 18.1744 12.6661 16.3023 13.3622C15.3834 13.8274 14.4762 14.6313 13.9683 15.7031C13.4633 16.7691 13.3364 18.135 14.0377 19.7714L14.1578 20.0273C14.7896 21.2644 15.897 21.8776 17.065 22.1318C18.3215 22.4051 19.5964 22.247 20.275 22.0224C20.8495 21.8041 21.6472 21.2424 22.2408 20.3808C22.8298 19.5257 23.2083 18.3918 22.98 17.0224C22.7483 15.632 21.9861 14.3753 20.8433 13.6396Z"
          fill={fillColor1}
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProfileUserCancelCloseIcon = (
  props: SVGProps<SVGSVGElement> & {
    fillColor1?: string;
    fillColor2?: string;
    fillColor3?: string;
  },
) => {
  const {
    fillColor1 = '#291547',
    fillColor2 = '#F6F3FE',
    fillColor3 = '#C6B5F4',
  } = props;
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M1.16386 13.771L1.98275 3.75541C2.10659 2.24071 3.34355 1.05789 4.86227 1.00192L18.2169 0.509696C18.4043 0.502789 18.5919 0.513466 18.7773 0.541587L19.2657 0.615667C20.7251 0.837027 21.8066 2.08708 21.8158 3.56311L21.881 14.067C21.8914 15.7367 20.5365 17.0936 18.8668 17.0856L4.1396 17.0155C2.39203 17.0072 1.02145 15.5128 1.16386 13.771Z"
          fill={fillColor1}
        />
        <path
          d="M18.3618 0.0578918C18.5234 0.0595008 18.6852 0.0726893 18.8452 0.0969543L19.3335 0.171173L19.643 0.23172C21.1623 0.605696 22.256 1.9688 22.2661 3.55984L22.3305 14.0638L22.3276 14.2434C22.2477 16.0213 20.8212 17.4493 19.0434 17.5315L18.8647 17.5354L4.13717 17.4651C2.12771 17.4554 0.551705 15.7375 0.71529 13.7346L1.53463 3.71902L1.55123 3.55692C1.76565 1.89324 3.15408 0.614398 4.84615 0.552032L18.2006 0.059845L18.3618 0.0578918ZM4.87838 1.45145C3.66843 1.49626 2.6694 2.38275 2.46236 3.55399L2.43111 3.79227L1.61275 13.8079C1.4918 15.2883 2.65667 16.5586 4.14205 16.5657L18.8686 16.636L19.1313 16.6233C20.3411 16.5056 21.3033 15.5422 21.4194 14.3323L21.4311 14.0696L21.3657 3.5657C21.3583 2.38965 20.5502 1.38217 19.4272 1.10574L19.1987 1.06082L18.7094 0.986603C18.5521 0.962762 18.3929 0.953418 18.2338 0.959259L4.87838 1.45145Z"
          fill={fillColor1}
        />
        <path
          d="M1 13.5V3.5C1 1.84315 2.34315 0.5 4 0.5H18.1C19.7568 0.5 21.1 1.84315 21.1 3.5V13.5C21.1 15.1569 19.7568 16.5 18.1 16.5H4C2.34315 16.5 1 15.1569 1 13.5Z"
          fill={fillColor2}
        />
        <path
          d="M20.6504 3.5C20.6504 2.09167 19.5079 0.950195 18.0996 0.950195H4C2.59167 0.950197 1.4502 2.09168 1.4502 3.5V13.5C1.4502 14.9083 2.59167 16.0498 4 16.0498H18.0996C19.5079 16.0498 20.6504 14.9083 20.6504 13.5V3.5ZM21.5498 13.5C21.5498 15.4054 20.005 16.9502 18.0996 16.9502H4C2.09462 16.9502 0.549805 15.4054 0.549805 13.5V3.5C0.549805 1.59462 2.09462 0.049806 4 0.0498047H18.0996C20.005 0.0498047 21.5498 1.59462 21.5498 3.5V13.5Z"
          fill={fillColor1}
        />
        <path
          d="M15.8995 4.24982C16.6097 4.24982 17.0738 4.27508 17.3653 4.30157C17.5112 4.31484 17.6152 4.32853 17.6856 4.33966C17.7206 4.34519 17.7476 4.3503 17.7677 4.35431C17.7777 4.35631 17.7863 4.35866 17.7931 4.36017C17.7963 4.3609 17.7993 4.36152 17.8018 4.36212C17.8031 4.36243 17.8046 4.36283 17.8058 4.3631H17.8087L17.8946 4.39435C18.0834 4.48479 18.1885 4.69806 18.1358 4.909C18.0755 5.14997 17.8319 5.29626 17.5909 5.23615L17.545 5.22931C17.4968 5.22169 17.4131 5.20978 17.2843 5.19806C17.0259 5.17457 16.5895 5.15021 15.8995 5.15021C15.21 5.15021 14.7741 5.17458 14.5157 5.19806C14.3867 5.20979 14.3022 5.22169 14.254 5.22931C14.2304 5.23303 14.2154 5.23469 14.2081 5.23615H14.2091C13.968 5.29648 13.7235 5.15009 13.6632 4.909C13.603 4.66799 13.7493 4.42343 13.9903 4.3631H13.9933C13.9944 4.36283 13.9959 4.36242 13.9972 4.36212C13.9997 4.36152 14.0027 4.3609 14.006 4.36017C14.0127 4.35866 14.0213 4.35632 14.0313 4.35431C14.0514 4.3503 14.0783 4.3452 14.1134 4.33966C14.1838 4.32854 14.2878 4.31484 14.4337 4.30157C14.7252 4.27507 15.1892 4.24982 15.8995 4.24982ZM17.5948 5.23712C17.5958 5.23736 17.5967 5.23807 17.5968 5.2381L17.5919 5.23712H17.5948Z"
          fill={fillColor1}
        />
        <path
          d="M15.8999 6.94916C17.1049 6.94952 17.7914 6.97508 18.1802 7.00092C18.3743 7.01382 18.4985 7.02664 18.5786 7.03803C18.6189 7.04376 18.6505 7.0494 18.6753 7.05463C18.6876 7.05723 18.699 7.0597 18.7095 7.06244C18.7147 7.06381 18.72 7.06584 18.7251 7.06733C18.7276 7.06804 18.7305 7.06852 18.7329 7.06928C18.7342 7.06969 18.7365 7.07081 18.7378 7.07123H18.7398L18.7407 7.07221C18.7404 7.07467 18.7321 7.10124 18.6333 7.39936L18.7417 7.07221C18.9773 7.15051 19.1048 7.40488 19.0269 7.64057C18.949 7.87546 18.6965 8.0028 18.4615 7.9267L18.4624 7.92768C18.4634 7.928 18.4644 7.92836 18.4654 7.92865C18.4677 7.92937 18.4702 7.93003 18.4722 7.93061C18.4761 7.93175 18.4794 7.93286 18.482 7.93354C18.4867 7.93478 18.4898 7.93549 18.4898 7.93549C18.4888 7.93528 18.477 7.93322 18.4517 7.92963C18.4006 7.92239 18.2997 7.91034 18.1197 7.89838C17.7586 7.8744 17.0947 7.84991 15.8999 7.84955C14.7046 7.8492 14.04 7.87424 13.6792 7.89838C13.4993 7.91043 13.3989 7.92136 13.3482 7.92865C13.323 7.93227 13.3119 7.93532 13.3111 7.93549C13.3111 7.93549 13.3141 7.93481 13.3189 7.93354C13.3214 7.93286 13.3248 7.93173 13.3286 7.93061C13.3306 7.93003 13.3332 7.92937 13.3355 7.92865C13.3366 7.92828 13.3381 7.92809 13.3394 7.92768L13.3413 7.9267H13.3423L13.3413 7.92572C13.1062 8.00383 12.852 7.87757 12.773 7.64252C12.694 7.40711 12.8209 7.15245 13.0562 7.07318L13.1997 7.49897C13.0585 7.07899 13.0567 7.07246 13.0572 7.07221H13.0581L13.0601 7.07123C13.0613 7.07083 13.0628 7.07064 13.064 7.07026C13.0665 7.06945 13.0693 7.06808 13.0718 7.06733C13.0771 7.06576 13.083 7.06486 13.0884 7.06342C13.0992 7.06057 13.111 7.05732 13.1236 7.05463C13.1485 7.04932 13.18 7.04381 13.2202 7.03803C13.3007 7.02647 13.4253 7.01295 13.6197 6.99994C14.0088 6.97391 14.6949 6.94881 15.8999 6.94916Z"
          fill={fillColor1}
        />
        <path
          d="M10.2999 8.29971C10.2999 10.2997 8.95678 11.2997 7.29993 11.2997C5.64307 11.2997 4.29993 9.95657 4.29993 8.29971C4.29993 6.64286 5.64307 5.29971 7.29993 5.29971C8.95678 5.29971 10.2999 6.29971 10.2999 8.29971Z"
          fill={fillColor2}
        />
        <path
          d="M7.5 11.8987C9.11298 11.8987 10.3644 12.5628 11.209 13.4397C12.0401 14.3025 12.5 15.3968 12.5 16.299H11.5C11.5 15.7013 11.1753 14.8452 10.4893 14.133C9.81679 13.4349 8.81861 12.8987 7.5 12.8987C4.83652 12.8987 3.5 14.7498 3.5 16.299H2.5C2.5 14.1816 4.30024 11.8987 7.5 11.8987Z"
          fill={fillColor1}
        />
        <path
          d="M9.39954 8.29971C9.39954 7.51265 9.1428 7.01687 8.81165 6.71182C8.46832 6.39562 7.95238 6.2001 7.29993 6.2001C6.14013 6.2001 5.20032 7.13992 5.20032 8.29971C5.20032 9.45951 6.14013 10.3993 7.29993 10.3993V11.2997C5.64307 11.2997 4.29993 9.95657 4.29993 8.29971C4.29993 6.64286 5.64307 5.29971 7.29993 5.29971C8.95678 5.29971 10.2999 6.29971 10.2999 8.29971C10.2999 10.2997 8.95678 11.2997 7.29993 11.2997V10.3993C7.95238 10.3993 8.46832 10.2038 8.81165 9.8876C9.1428 9.58255 9.39954 9.08677 9.39954 8.29971Z"
          fill={fillColor1}
        />
        <path
          d="M13.6239 20.1468C12.124 16.6468 14.124 14.1469 16.124 13.1468C20.124 11.6468 22.9239 14.1468 23.4239 17.1468C23.924 20.1468 21.7572 22.1468 20.4239 22.6468C18.9239 23.1468 14.9793 23.3095 13.6239 20.1468Z"
          fill={fillColor3}
        />
        <path
          d="M15.9664 12.7258C18.085 11.9314 19.9354 12.184 21.3297 13.0813C22.7115 13.9706 23.5994 15.4632 23.8677 17.0725C24.1395 18.703 23.6846 20.0702 22.982 21.0901C22.2873 22.0984 21.3396 22.7843 20.5816 23.0686L20.5738 23.0715L20.566 23.0735C19.7429 23.3478 18.2994 23.5203 16.8736 23.2102C15.4337 22.8969 13.9616 22.0766 13.2105 20.3244C12.4119 18.4609 12.5348 16.8257 13.1548 15.5168C13.7678 14.2228 14.8493 13.281 15.9224 12.7444L15.9439 12.7336L15.9664 12.7258ZM20.8433 13.8381C19.7168 13.1131 18.1744 12.8647 16.3023 13.5608C15.3834 14.0259 14.4762 14.8298 13.9683 15.9016C13.4633 16.9676 13.3364 18.3335 14.0377 19.9699C14.642 21.3796 15.8191 22.0592 17.065 22.3303C18.3215 22.6036 19.5964 22.4455 20.275 22.2209C20.8495 22.0026 21.6472 21.4409 22.2408 20.5793C22.8298 19.7242 23.2083 18.5903 22.98 17.2209C22.7483 15.8306 21.9861 14.5738 20.8433 13.8381Z"
          fill={fillColor1}
        />
        <path
          d="M16.1879 15.5132C16.3511 15.3258 16.6358 15.3058 16.8233 15.469L16.826 15.4718C16.8278 15.4734 16.8307 15.4758 16.8342 15.4788C16.8412 15.485 16.8515 15.4946 16.8648 15.5063C16.8914 15.5298 16.9302 15.5638 16.9792 15.6076C17.0775 15.6955 17.2182 15.8222 17.3861 15.9775C17.7167 16.2832 18.1572 16.7021 18.5996 17.1582L20.1999 15.6061C20.3784 15.4334 20.6636 15.4381 20.8365 15.6165C21.0093 15.7951 21.0047 16.0803 20.8261 16.2531L19.216 17.8147C19.4881 18.1098 19.7587 18.4081 19.9908 18.6685C20.1938 18.8963 20.4694 19.1953 20.5939 19.3375C20.6562 19.4086 20.7056 19.4658 20.7397 19.505C20.7567 19.5245 20.7701 19.5395 20.779 19.5498C20.7835 19.5549 20.7869 19.559 20.7892 19.5617L20.7933 19.5659C20.9557 19.7538 20.9348 20.038 20.747 20.2005C20.5591 20.3632 20.275 20.3422 20.1124 20.1543L20.109 20.1508C20.1068 20.1483 20.1037 20.1444 20.0995 20.1396C20.0908 20.1296 20.0776 20.1147 20.0608 20.0954C20.0273 20.0569 19.978 20.001 19.9164 19.9308C19.7932 19.79 19.5196 19.4929 19.3187 19.2674C19.0921 19.0131 18.8308 18.725 18.569 18.4409L16.8025 20.1475C16.6239 20.3204 16.3388 20.3157 16.1659 20.1372C15.9932 19.9586 15.9978 19.6734 16.1763 19.5006L17.9527 17.7844C17.5254 17.344 17.0982 16.9368 16.7752 16.6381C16.6116 16.4869 16.4749 16.3638 16.3798 16.2788C16.3322 16.2363 16.2947 16.2025 16.2695 16.1803C16.2573 16.1695 16.2479 16.1612 16.2416 16.1557C16.2384 16.1529 16.2356 16.1507 16.2341 16.1493L16.2328 16.1479C16.0454 15.9848 16.0249 15.7006 16.1879 15.5132Z"
          fill={fillColor1}
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IdCardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M14.7508 13.0502H16.2508M14.7508 10.0502H16.2508M6.99932 17.0002C7.43346 15.4777 8.39023 13.7502 9.50074 13.7502C10.6113 13.7502 11.568 15.4777 12.0022 17.0002M12.0008 5.9502H5.55078C4.9985 5.9502 4.55078 6.39791 4.55078 6.9502V16.2502C4.55078 16.8025 4.9985 17.2502 5.55078 17.2502H18.4508C19.0031 17.2502 19.4508 16.8025 19.4508 16.2502V6.9502C19.4508 6.39791 19.0031 5.9502 18.4508 5.9502H12.0008ZM9.50078 13.2502C10.4673 13.2502 11.2508 12.4667 11.2508 11.5002C11.2508 10.5337 10.4673 9.75019 9.50078 9.75019C8.53428 9.75019 7.75078 10.5337 7.75078 11.5002C7.75078 12.4667 8.53428 13.2502 9.50078 13.2502Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
